webpackJsonp([0],[
/* 0 */,
/* 1 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(26),
  /* template */
  __webpack_require__(94),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 2 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(25),
  /* template */
  __webpack_require__(87),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 3 */
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAACAAAAAQCAMAAABA3o1rAAAAQlBMVEUAAACqqqqqqqqqqqqqqqqqqqqqqqqqqqqqqqqqqqqqqqqqqqqqqqqqqqqqqqqqqqqqqqqqqqqqqqqqqqqqqqqqqqrDGsyVAAAAFnRSTlMA/vhH6fNB7DTuVIQunp2McGw8IxwaWU9GagAAAIVJREFUKM99kFkOBCEIBVlc0N63+191yGQ6jGnp+pLUExGQWcBFJoE5E3ueKU8gGCj1faKAojFN1J6v6vkbxBy3p99ixl/rEUscrlZfQyw43tX5X9mdE4xV++1W7vrq2p9IceZOluD+z5kCsR1a7KK1chK1ev5ema2nh2ApKPDCsSwHNHwA8iUDi6EMHsQAAAAASUVORK5CYII="

/***/ }),
/* 4 */
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAE4AAABOCAMAAAC5dNAvAAAA7VBMVEUzMzMAAACqqqrAwMBxcXGqqqqqqqrJyclISEiqqqqqqqpmZmaJiYlCQkKDg4N0dHRcXFyqqqr19fU8PDxVVVWqqqqqqqqPj4+qqqr+/v6mpqahoaGqqqqqqqqqqqpXV1eqqqpERET8/Pz6+vrx8fHd3d3Q0NCvr695eXmqqqqqqqpkZGSqqqqqqqrv7+/t7e3Y2Ni4uLizs7Ofn5+SkpKCgoJ7e3uqqqpeXl5NTU3y8vLv7+/Ly8vDw8OmpqaZmZk1NTWOjo5OTk739/f19fXl5eXj4+Pi4uLa2tp1dXWqqqqqqqqNjY2qqqr///+oYkRMAAAATnRSTlNmAGauZgoWt2ZCGXhmZmZmZlbtZ2ZeTGYz/mZmLikEckVr+fXnzL2gZjUdZiIN4+HHp6SWjYWBO3Vu6eW5sZuSZ4tv8e7W1NLJfzo3iyHceRLBAAAEIUlEQVRYw72Y6VrqMBCGI6WFFgW1yiZSKrK5s6Pgvus5vf/LOUlDpJlpCT3Pg99PGF4yM5lJMmRDJd04O6wUi5XDM0NXGi/HGZ38fiKg/XzH+E9c9cRMhMo8qcbGGV9iWQeFbDuXTOba2cKBWOSXEQtn1fjvCrk9mwRk7+UK/JuatTLO4LDN7S0Soq3tTQ40VsLpHWZczqVJpNK5MrPp6GqcscMsk2BhaIlJZrVjqHCHzCybJkqls8zycClON5mfe2Ql7TGPTT0ap+dZNqGf0R6zLOf1KNw5C1uSxFCSBfA8HKcz2imJpVPAI7Kn2ySmtrm/GGcKWnyeiXGVSE+dQU9LpbTewIn0twJxVngWHh6bx96PjpuPD+H5sARukYZNZOh2BWtB7LrIbJOmQ5dwRdqItuDKWi9eiF5acIVbtHEVgziDrhfWQubVi9BrBtYH/bkRwNVonQKT+7oXqfo9MKb1W+M4kQdQ9a1SIF6NmabNGoE4llqgH/jZEDgTZbXnCV10Mz/udy88oR7KrilwNHJleXH9koABt+4FsNSXl1dmy+O4cSKRk74cHs1/o9kEyNbm/3Q0lD7PJRJjjqvug8i58yjVByREg/o8oi6I3n7Vx53AHdzk9s8jEqrRM/++CffyiY8zQel/lrA3YbEofYJWYDJclSZZKoh3/ud3JFJ33OJdKg2KqVKcBXwdcdsrskRX3GYEvLUorkM3HTatT5bhnDr/S7D1OhSXl8vV5YG5JUt1y8PryoWbpzi6TWwUlyNnOc45QvG16VbZIDptTdjXD6LQB/aWtimd0AorkIB2fbu+Ctf3zXZJQAXapciZ3JsmfEs9qXDXfHNO5C51RuilpE0W+sMrnyjFe8EjWahNryykItd/y7dqqHEN37Ald4EKKcrbTvOtZmrczDfU5I1XhLgUsAKC/5sCOOBsbBxwFqQiNg6kAmyU2Di4UcQ2xjhHa/ZcSHF7Tc3BOLGNRZFh3Ih1jakDanXKus0I4USRiRaAcZeig+O+fwlxogWIBoVxjufrRsbd8E8dgBMNSrRPjMt4oshxg/AyACfaJ2ju8XGgucOjp8v7kwonOlQXHT0bteDBeH3DQm2rcfYli+w1OBjRsf2UamguUeOIqzVST+DYBpcKITWOCV0q4JUnPg5feVhuy+mI7j0lkqa894uQoQsZvi4KvYnzFp+vb2GPARNcZoEmLHUNG1zvGizx7MDBl1lw1YayB60hQRq2BuAv0FUbPwTUwg8B/EyJL/xMwY8otfAjSv3EUws/8fADVC38AF3D83gNj3c0WohP29HXPPgQvNhjGUZbw9BorSMtPHBLK2DKgZuQXlx1HFjUf2NYiWWZCU5MwlFqkrMSphVv0DsGg952NjDoHRu/P4bGsr7hkPwbOAkUY4T/d4UR/j8fUf4vgWbsWgAAAABJRU5ErkJggg=="

/***/ }),
/* 5 */
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAE4AAABOCAMAAAC5dNAvAAAA3lBMVEUzMzMAAACqqqpycnKqqqpISEiqqqrv7++qqqrAwMD6+vqJiYmbm5uDg4OqqqpdXV1BQUGPj4+qqqqlpaWqqqqqqqqqqqqqqqqqqqpYWFiqqqqqqqqqqqp5eXlTU1M8PDyqqqqqqqqqqqqqqqqqqqr9/f2qqqr19fVdXV2goKBlZWWqqqr39/fj4+PY2Ni7u7uDg4PNzc13d3dmZmaqqqr8/Pzw8PDs7OzQ0NCrq6uhoaGSkpJRUVFJSUnx8fHn5+ff39/d3d3IyMjExMSlpaU/Pz+fn5/R0dGxsbH///+wiySOAAAASXRSTlNmAGZmCmYY5EKu9maTZl5mZmYzZksWLikFZlhFNmZmZmRSOiIc/A3tdGZmFPHTxqqFu394Hvjm4L6el45wbefYz8y2splqZr+i8J4yVQAAA2lJREFUWMPFmGtX4jAQhoONtaKFUilULKBcBAW5KOsNWNfrLv//D+2MFQYkSZuenuP7hQ+E50yYyWTyskyUuNcsl1y3VG56PHKxGmcGxdzOmnLFwEyI81vW6Y5Ap1bL18aZjWVYFwW7aoCqduFiGWTD1MKZJ+HvCkatztZUrxmF8JsTMzbOC2EHeYcJ5OQPQqAXC8cDXHxk7DKpdo0jXBPwaJxXwZWGw5RyDFxV8aJwZVxmU2TyCG1cWVbiuIX7PGaxdIw7trgcx4uYTQotKkDMcpHLcOdn+K8xDeE/eHYuxnGkXTItXWJC1nhsc6d5pqk8xscFOEuLRgnBfGzjSrRT/f2WvuPMrSxo5cPcxPEKnFGWUAeQDr6Bc6F6naQ4B+rZXcf1IF7RWbh5nN7ETEdvDQcdyWbb6mYXi0Vn8DaL4tnQrwiHeRAdrcPFl+5epu/K44bZWOEscVYBR/p1NbxWZtcKcRScBEfqDx666vAQ16DgZDjS3rgrCa8R4vwcBCfDZf89Z78B29fi8HL+J65FFSzAwcdo/6m9zruT1HILcZiIvBIHmh+O91a4jqS1WIjz4a53FDiqwodB/xN3KzwaMB/4gKO9SnGk6yvMBpPtFnAB5TUax/YJt53bAHDQhGtp4GpwDQEOyqSeBq4OpZJhHGYklgaOwXzFmQc3azo4uHU91qTelBRHXarJYCipMoGm4+f7Vy1cFUYWVhLWyfxqgdLCQaWUmCvEAS0JzhXjDqlr6uHEmx1QN9LbrDgVT4TTS4W4UP5Qb9MrFHEZD1e4fa0yNsWHbN5ZXjYzvUMmaQGjflgmI6bVAqQNqnvfaXf+wkSh26AC9SSm2z6puUfrZvSibu509UTr8fbr5lZdPZmTeDMxVc+e6mLMTOLtdrRY6lay14liqFCc475qqKCRR63fK1xWOvLQQKaB6wiCg/HYVIyL0o4KuleNi3HDe6SBTDwtqkdtadd6VY/a9BBQ633cxm4/lDwE9J8p3Yfh20zxTEn/EZX+Ey/9Byg9j5M8ty3Z4/04yWO7yKXWQj6JFSAxPipJjI/KlvFBRoqWLeMUyEZJ1TRK39JSG267EbAIw43E3bh2oMtjmZW9eGZlL76Vau2ExG0rFVgoy0xo9H6ERm/Vtgsf2kYvyZ/IbOiJ//MmeSIL/z/55Z84fRqpHQAAAABJRU5ErkJggg=="

/***/ }),
/* 6 */,
/* 7 */
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAACYAAAAqCAMAAADoIdnnAAAAkFBMVEUAAAD///////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////+WABnwAAAAL3RSTlMAlqoepfC7Z/rStIo+PBn06dzCsJ9dJRYK5NfIeWNZRDUvKxIPBu2ye29I9n1yVruWnJ0AAAEPSURBVDjL7dRLb4JAFIbhT6sDFgqUuyCC4KXay/n//66Tk5TgeMakiy6a+Gy4nJcwswBM7HClh8xvMbHNYfFWYjR8wqY4+14dEUWx121K2HytaVRdIBsSupKW4hsrelXKJRYqtaZ4jxuHmmgDLImtgBlRIuySbjPKYCj13HypvgHDlkS+kc3k7MPITnKWYhS0A+4o/D2vyqXwgvNc1CBz6dgBB94iFiSa8bgGnvjSmvF4+cj+OAvuZzyOAKz0UVkzHi8A5OqYBNZMj6P5+IXZM/bbLJUzz8j8d6kKexh6x1nx847GS4idJofgmbQXaM7Puv5bxn9L/utnvGeIeFjxWbEkcjtYNHEagO1OqsXENwjHjiEIw2wHAAAAAElFTkSuQmCC"

/***/ }),
/* 8 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/gzheader.81b2bbe.png";

/***/ }),
/* 9 */
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAACYAAAAqCAMAAADoIdnnAAAAk1BMVEUAAAD////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////ROyVeAAAAMHRSTlMA/Pfhswjy1qxtTRoC65mDW1EwD9LNwLmmoHBgWEhFQTwlHQXt5YxkNSsh2sl1dBb7cU3+AAABI0lEQVQ4y5XU6XKCMBSG4RN2EWUHUaTWtbXbuf+rK4YQy3T40OcPw/gOAieBRjQr842m7Etmnsx2Drd+CEtklREWZHzzRVgkq1NKWCEznzBbcGtGE17byHwZ/zm++Nf2OHet2m4P2020s2noMHP55iNM5Ov9zuWps7wO3pTLmml5udBnxpq0rcPjqqCfjcFISFJqwmql3vMZVkvqpPAvi0CPEBDvpCxRVlIvR9l9tAuU3WfLSKIz8djVjo/dm4syT2cWyow9KSEjlV5FDG1UZuNlJPrOY8zr5hrzhM9uu5iMxSStcZUF6iHw5RpSajwIrRyvjnPS5uOLrqY/fDGxsQg+rXWgoUs3M2HN/CY6n9RWtv9/uKqF4YbqhoPYWjiFT0/6BV6Kp7S6/nGmAAAAAElFTkSuQmCC"

/***/ }),
/* 10 */
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,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"

/***/ }),
/* 11 */,
/* 12 */,
/* 13 */,
/* 14 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/czheader.a2d614b.png";

/***/ }),
/* 15 */
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,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"

/***/ }),
/* 16 */
/***/ (function(module, exports) {

module.exports = {"classes":[{"id":1,"title":"人教版 B1U1  go through","date":"2017-03-12 13:25:14","img_url":"../../../static/images/cz1.png","desc":"go through为高频多义短语动词，学生最熟悉的释义是“穿过”，是该短语的字面意义，也是其基本意，强调从一端到另一端或从“头”到“尾”，可根据这一释义启发学生理解不同语境下的其他释义。","content":"<p style=\"text-align:center\"><img src=\"http://source.weicistudy.com/web/images/1.jpg\" style=\"width:940px;\"/></p><p style=\"text-align: center;\">    <img src=\"http://source.weicistudy.com/web/images/2.jpg\" style=\"width:940px;\" /></p><p style=\"text-align: center;\">    <img src=\"http://source.weicistudy.com/web/images/3.jpg\" width=\"940\" height=\"592\" style=\"width: 940px; height: 592px;\"/></p><p style=\"text-align: center;\">    <img src=\"http://source.weicistudy.com/web/images/4.jpg\" width=\"940\" height=\"588\" border=\"0\" vspace=\"0\" title=\"\" alt=\"\" style=\"width: 940px; height: 588px;\"/></p><p style=\"text-align: center;\">    <img src=\"http://source.weicistudy.com/web/images/5.jpg\" style=\"width:940px;\"/></p>"},{"id":2,"title":"人教版 B1U1  settle","date":"2017-02-12 11:22:01","img_url":"../../../static/images/cz2.png","desc":"为什么反反复复背单词，记释义，还是不能全部掌握？ 为什么反反复复教单词，学生还是记不住？","content":"<p>   <span style=\"font-size: 14px; font-family: 微软雅黑, &quot;Microsoft YaHei&quot;;\"><span style=\"font-size: 14px;\">为</span>什么反反复复背单词，记释义，还是不能全部掌握？ 为什么反反复复教单词，学生还是记不住？</span></p><p>    <span style=\"font-size: 14px; font-family: 微软雅黑, &quot;Microsoft YaHei&quot;;\"><img src=\"http://source.weicistudy.com/web/images/6.jpg\"/></span></p><p>    <span style=\"font-size: 14px; font-family: 微软雅黑, &quot;Microsoft YaHei&quot;;\"></span></p><p>    <span style=\"font-size:16px;font-family:宋体\">无论学习哪一门语言，词汇学习都是重中之重。词汇或者说语言都是有生命的，它们时刻处于变化之中。一个词汇的释义会随着社会的发展，不断地衍生新的释义</span><span style=\"font-size:16px\">, </span><span style=\"font-size:16px;font-family:宋体\">而新的词汇也层出不穷，据说，英语总词汇量最近已经突破</span><span style=\"font-size:16px\">100</span><span style=\"font-size:16px;font-family:宋体\">万个，看到这里，相信很多小伙伴已哭晕，心情久久不能</span><span style=\"font-size:16px\">settle</span><span style=\"font-size:16px;font-family:宋体\">吧，还能不能愉快地学英语了？不用怕，让小</span><span style=\"font-size:16px\">V</span><span style=\"font-size:16px;font-family:宋体\">来帮大家</span><span style=\"font-size:16px\">settle</span><span style=\"font-size:16px;font-family: 宋体\">这个问题，轻松愉快地学习英语。方法很重要！</span></p><p style=\"text-align: center;\">    <img src=\"http://source.weicistudy.com/web/images/7.jpg\"/><span style=\"font-size: 14px; font-family: 微软雅黑, &quot;Microsoft YaHei&quot;;\"></span><br/></p><p>    <strong><span style=\"font-size:19px;font-family:宋体\">教学建议</span></strong></p><ul class=\" list-paddingleft-2\" style=\"list-style-type: square;\">    <li>        <p>            <span style=\"font-family:宋体\">培养学生<span style=\"color:red\">建立基本义</span></span><span style=\"color:red\"> (</span><span style=\"font-family:宋体;color:red\">或词源义</span><span style=\"color:red\">) </span><span style=\"font-family:宋体;color:red\">和衍生义之间的联系</span><span style=\"font-family:宋体\">以及<span style=\"color:red\">依据基本义在语境中推测词义</span>的能力。根据</span>settle<span style=\"font-family:宋体\">的词源义“<span style=\"color:red\">停止移动、定下来</span>”启发学生理解各层<span style=\"color:red\">衍生义</span>；</span>        </p>    </li>    <li>        <p>            <span style=\"font-size:14px;font-family:宋体\">掌握</span><span style=\"font-size:14px;font-family:&#39;Calibri&#39;,sans-serif\">settle</span><span style=\"font-size:14px;font-family:宋体\">各层释义下的相关搭配；</span>        </p>    </li>    <li>        <p>            <span style=\"font-size:14px;font-family:宋体\">重点掌握</span><span style=\"font-size:14px;font-family:&#39;Calibri&#39;,sans-serif\">settle down</span><span style=\"font-size:14px;font-family:宋体\">的释义，了解其他短语动词的释义。</span>        </p>    </li></ul><p>    <strong><span style=\"color:#0070C0\">settle</span></strong><strong><span style=\"font-family:宋体;color:#0070C0\">词源义</span><span style=\"color:#0070C0\">:</span></strong></p><p>    <img src=\"http://source.weicistudy.com/web/images/8.jpg\"/></p><p>    <strong><span style=\"color:#0070C0;background:white\">settle</span></strong><strong><span style=\"font-family:宋体;color:#0070C0;background:white\">释义、用法和搭配：</span></strong></p><p>    <img src=\"http://source.weicistudy.com/web/images/9.jpg\"/></p><p>    <img src=\"http://source.weicistudy.com/web/images/10.jpg\"/></p><p>    <strong><span style=\"color:#0070C0;background:white\">NOTE</span></strong><strong><span style=\"font-family:宋体;color:#0070C0;background:white\">：</span></strong></p><p>    <span style=\"font-size:16px\">1.&nbsp;</span><span style=\"font-size:16px;font-family:宋体\">在英语词汇学习中给中国学生带来最大困难的是那些出现频率较高、词义较多、用法灵活且与其他词搭配能力强的</span><span style=\"font-size:16px\"> “</span><span style=\"font-size:16px;font-family:宋体;color:red\">高频多义词</span><span style=\"font-size:16px\">”</span><span style=\"font-size:16px;font-family:宋体\">，应引起重视；</span></p><p>    <span style=\"font-size:16px\">2.&nbsp;</span><span style=\"font-size:16px;font-family:宋体\">在平时的教学中应有意识地培养学生<span style=\"color:red\">根据具体语境通过词汇基本义推测衍生义</span>的能力，这也是<span style=\"color:red\">英语语用能力</span>很重要的一方面，注重培养学生的<span style=\"color:red\">思维能力</span>，避免死记硬背词汇各个义项；</span></p><p>    <span style=\"font-size:16px\">3.&nbsp;</span><span style=\"font-size:16px;font-family:宋体\">从基本义到衍生义是有一些共同规律的：</span><span style=\"font-size:16px;color:red\"></span><span style=\"font-size: 16px;font-family:宋体;color:red\">由人到物或由物到人；‚由表及里或由外到内；由个体到群体；</span><span style=\"font-size:16px;color:red\">m</span><span style=\"font-size: 16px;font-family:宋体;color:red\">由局部到整体；</span><span style=\"font-size:16px;color:red\">n</span><span style=\"font-size: 16px;font-family:宋体;color:red\">由一种事物到另一种事物或由事物的某一方面到另一方面；由具象到抽象。</span><span style=\"font-size:16px\">(</span><span style=\"font-size:16px;font-family:宋体\">参见</span><span style=\"font-size:16px\">settle</span><span style=\"font-size:16px;font-family: 宋体\">的词义网络</span><span style=\"font-size:16px\">)</span></p><p>    <strong><span style=\"font-family:宋体;color:#0070C0;background:white\">练习题：</span></strong></p><p>    <span style=\"font-size:16px;font-family:宋体\">一、根据句意选出与</span><strong><span style=\"font-size:16px\">settle</span></strong><span style=\"font-size: 16px;font-family:宋体\">的释义最接近的短语。</span></p><p>    <span style=\"font-size:16px\">&nbsp;1. She paid the driver and then, using her hands to feel the seats,&nbsp;settled&nbsp;in one of them. (2010&nbsp;</span><span style=\"font-size:16px;font-family:宋体\">湖北完形</span><span style=\"font-size: 16px\">)</span></p><p>    <span style=\"font-size:16px\">&nbsp;2. When I<strong>&nbsp;settled&nbsp;</strong>in Chicago, my new city seemed so big and unfriendly. (2012&nbsp;</span><span style=\"font-size:16px;font-family:宋体\">安徽完形</span><span style=\"font-size:16px\">)</span></p><p>    <span style=\"font-size:16px\">&nbsp;3. They have&nbsp;<strong>settled</strong>&nbsp;their environmental problems. (2014&nbsp;</span><span style=\"font-size:16px;font-family:宋体\">全国阅读</span><span style=\"font-size:16px\">)</span></p><p>    <strong><span style=\"font-size:16px\">&nbsp;settle</span></strong><span style=\"font-size:16px\">&nbsp;1. ___________ (sit down, calm down)</span></p><p>    <strong><span style=\"font-size:16px\">&nbsp;settle</span></strong><span style=\"font-size:16px\">&nbsp;2. ___________ (arrive in, move to)</span></p><p>    <strong><span style=\"font-size:16px\">&nbsp;settle</span></strong><span style=\"font-size:16px\">&nbsp;3. ___________ (deal with, come up with)</span></p><p>    <span style=\"font-size:16px\">&nbsp;</span></p><p>    <span style=\"font-size:16px;font-family:宋体\">二、根据句意写出画线部分的汉语释义。</span></p><p>    <span style=\"font-size:16px\">___________ 1. The man let his eyes settle upon Peter&#39;s face.</span></p><p>    <span style=\"font-size:16px\">___________ 2. An uneasy silence&nbsp;settled&nbsp;over the room.</span></p><p>    <span style=\"font-size:16px\">___________ 3. I&nbsp;settled&nbsp;the bill for my coffee and his two glasses of wine.</span></p><p>    <span style=\"font-size:16px\">___________ 4. She didn&#39;t start the lesson until the pupils&nbsp;settled down.</span></p><p>    <span style=\"font-size:16px\">&nbsp;</span></p><p>    <span style=\"font-size:16px\">&nbsp;</span></p><p>    <span style=\"font-size:16px;color:gray\">&nbsp;</span></p><p>    <span style=\"font-size:16px;font-family:宋体;color:gray\">参考答案：</span></p><p>    <span style=\"font-size:16px;font-family:宋体;color:gray\">一、</span><span style=\"font-size:16px;color:gray\">1. sit down &nbsp;2. move to &nbsp;3. deal with &nbsp;&nbsp;&nbsp;&nbsp;</span></p><p>    <span style=\"font-size:16px;font-family:宋体;color:gray\">二、</span><span style=\"font-size:16px;color:gray\">1.&nbsp;</span><span style=\"font-size:16px;font-family: 宋体;color:gray\">落在</span><span style=\"font-size:16px;color:gray\">&nbsp;/&nbsp;</span><span style=\"font-size:16px;font-family:宋体;color:gray\">停留</span><span style=\"font-size:16px;color:gray\"> &nbsp;&nbsp;2.&nbsp;</span><span style=\"font-size:16px;font-family:宋体;color:gray\">弥漫</span><span style=\"font-size:16px;color:gray\">&nbsp;/&nbsp;</span><span style=\"font-size:16px;font-family:宋体;color:gray\">充满</span><span style=\"font-size:16px;color:gray\"> &nbsp;&nbsp;3.&nbsp;</span><span style=\"font-size:16px;font-family:宋体;color:gray\">结清</span><span style=\"font-size:16px;color:gray\">&nbsp;/&nbsp;</span><span style=\"font-size:16px;font-family:宋体;color:gray\">结算</span><span style=\"font-size:16px;color:gray\"> &nbsp;&nbsp;4.&nbsp;</span><span style=\"font-size:16px;font-family:宋体;color:gray\">安静下来</span></p><p>    <br/></p>"},{"id":3,"title":"人教版 B1U1  upset","date":"2017-05-12 06:09:26","img_url":"../../../static/images/cz3.png","desc":"upset词性多、释义多，用法和搭配也不少，有什么好的方法能帮助我们记忆呢？","content":"<p>     <span style=\"font-size:16px;font-family:宋体\">今天我们要学习的单词是</span><span style=\"font-size:16px\">upset</span><span style=\"font-size:16px;font-family:宋体\">，它出现在人教</span><span style=\"font-size:16px\">Book 1 Unit 1</span><span style=\"font-size:16px;font-family:宋体\">的</span><span style=\"font-size:16px\">Warming up</span><span style=\"font-size:16px;font-family:宋体\">中：</span> </p> <p>     <span style=\"font-size:16px\">Your friend comes to school very <strong><span style=\"color:red\">upset</span></strong>. The bell rings so you need to go to class. You will&nbsp;________. </span> </p> <p>     &nbsp; </p> <p>     <span style=\"font-size:16px\">upset</span><span style=\"font-size:16px;font-family:宋体\">词性多、释义多，用法和搭配也不少，有什么好的方法能帮助我们记忆呢？首先我们看一下</span><span style=\"font-size:16px\">upset</span><span style=\"font-size:16px;font-family:宋体\">的词源：</span> </p> <p>     <img src=\"http://source.weicistudy.com/web/images/11.jpg\"/> </p> <p>     <span style=\"font-size:16px;font-family:宋体;color:#0070C0\">研究词源后不难发现，</span><span style=\"font-size:16px;color:#0070C0\">upset</span><span style=\"font-size:16px;font-family:宋体;color:#0070C0\">的形容词源自于动词，而动词的词源义“安装</span><span style=\"font-size:16px;color:#0070C0\"> (to set up, fix)</span><span style=\"font-size:16px;font-family:宋体;color:#0070C0\">”已消失不用了，最早出现的现代意义“弄翻；打翻”是它的基本义。基本义结合不同的语境，又衍生出了新的释义。</span> </p> <p style=\"text-align: center;\">     <img src=\"http://source.weicistudy.com/web/images/12.jpg\"/> </p> <p>     <img src=\"http://source.weicistudy.com/web/images/13.jpg\"/> </p> <p style=\"text-align: center;\">     <img src=\"http://source.weicistudy.com/web/images/14.jpg\"/> </p> <p style=\"text-align: center;\">     <img src=\"http://source.weicistudy.com/web/images/15.jpg\"/> </p> <p style=\"text-align: center;\">     <img src=\"http://source.weicistudy.com/web/images/16.jpg\"/> </p> <p>     <strong><span style=\"font-size:19px;font-family:宋体;color:#0070C0\">小贴士</span></strong> </p> <p>     <span style=\"font-size:16px;font-family:宋体\">动词释义“使生气；使心烦意乱”是几个意思的综合，在汉语里很难找到一个精准的词与之对应，因此，必须借助英语释义帮助学生准确的理解该层释义。</span> </p> <p>     <img src=\"http://source.weicistudy.com/web/images/17.jpg\"/> </p> <ul class=\" list-paddingleft-2\" style=\"list-style-type: square;\">     <li>         <p>             <strong><span style=\"font-size:16px;font-family:&#39;Calibri&#39;,sans-serif\">upset</span></strong><span style=\"font-size: 16px;font-family:&#39;Calibri&#39;,sans-serif\">&nbsp;</span><span style=\"font-size:16px;font-family: 宋体\">的形容词是动词形式的分词形容词，表示被动，因此可通过动词帮助理解形容词的释义。</span>         </p>     </li>     <li>         <p>             <span style=\"font-size:16px;font-family: &#39;Calibri&#39;,sans-serif\">a<strong>n&nbsp;upset&nbsp;stomach&nbsp;</strong></span><span style=\"font-size:16px;font-family:宋体\">是个固定搭配，意为“肠胃不适”，仅从字面上很难准确理解该搭配，容易给学生造成阅读理解障碍，需重点记忆。</span>         </p>     </li>     <li>         <p>             <span style=\"font-size:16px;font-family:宋体\">牢记</span><strong><span style=\"font-size:16px;font-family:&#39;Calibri&#39;,sans-serif\">upset</span></strong><span style=\"font-size:16px;font-family:宋体\">形容词的三种句型结构，其中结构</span><strong><span style=\"font-size:16px;font-family:&#39;Calibri&#39;,sans-serif\">&nbsp;(be) upset about&nbsp;</span></strong><span style=\"font-size:16px;font-family:宋体\">在历年高考中出现频度最高。</span>         </p>     </li> </ul> <p>     <br/> </p> <p>     <strong><span style=\"font-size:19px;font-family:宋体;color:#0070C0\">考考你：</span></strong> </p> <p>     <span style=\"font-size:16px;font-family:宋体\">一、写出下列句子中</span><span style=\"font-size:16px\">upset</span><span style=\"font-size:16px;font-family:宋体\">的汉语释义。</span> </p> <p>     <span style=\"font-size:16px\">1. Keep in mind that forgiveness does not necessarily mean becoming friends again with the person who upset&nbsp;you. (2013 </span><span style=\"font-size:16px;font-family:宋体\">辽宁</span><span style=\"font-size:16px\">) &nbsp;</span> </p> <p>     <span style=\"font-size:16px\">2. The fact that he has failed several times makes him very upset. (2007 </span><span style=\"font-size:16px;font-family:宋体\">湖北</span><span style=\"font-size:16px\">) </span> </p> <p>     <span style=\"font-size:16px;font-family:宋体\">二、在空白处填入适当的内容</span><span style=\"font-size:16px\">&nbsp;(1</span><span style=\"font-size:16px;font-family:宋体\">个单词</span><span style=\"font-size:16px\">)&nbsp;</span><span style=\"font-size:16px;font-family:宋体\">或括号内单词的正确形式。</span> </p> <p>     <span style=\"font-size:16px\">1.&nbsp;By the time I reached the farm I was very tired and upset __________ Goldie. (2010 </span><span style=\"font-size:16px;font-family:宋体\">北京</span><span style=\"font-size:16px\">) </span> </p> <p>     <span style=\"font-size:16px\">2. Nobel was upset __________ (find) out that he hadn’t discovered the truth. (2009 </span><span style=\"font-size:16px;font-family:宋体\">广东改</span><span style=\"font-size:16px\">)</span> </p> <p>     <span style=\"font-size:16px\">3. Walking towards the scene, Tenyson became very upset __________ what had happened to the couple. (2014 </span><span style=\"font-size:16px;font-family:宋体\">福建</span><span style=\"font-size:16px\">) </span> </p> <p>     <span style=\"font-size:16px\">&nbsp;</span> </p> <p>     <span style=\"font-size:16px;font-family:宋体;color:gray\">参考答案：</span> </p> <p>     <span style=\"font-size:16px;font-family:宋体;color:gray\">一、</span> </p> <p>     <span style=\"font-size:16px;color:gray\">1. </span><span style=\"font-size:16px;font-family:宋体;color:gray\">使生气；使心烦意乱</span><span style=\"font-size:16px;color:gray\">&nbsp;&nbsp;2. </span><span style=\"font-size:16px;font-family:宋体;color:gray\">心烦意乱的；难过的</span> </p> <p>     <span style=\"font-size:16px;font-family:宋体;color:gray\">二、</span> </p> <p>     <span style=\"font-size:16px;color:gray\">1. with &nbsp;2. to find &nbsp;3. about</span> </p>"},{"id":4,"title":"人教版 B1U1  recover","date":"2017-06-03 09:45:23","img_url":"../../../static/images/cz3.png","desc":"recover最常见的释义是“恢复健康”，但高考中也出现过其他的释义，那如何记忆呢？","content":"<p>     <span style=\"font-size:16px;font-family:宋体\">今天，我们要学的单词是</span><strong><span style=\"font-size:16px;color:red\">recover</span></strong><span style=\"font-size:16px;font-family:宋体\">。它出现在人教版必修</span><span style=\"font-size:16px\">1 Unit 1</span><span style=\"font-size:16px;font-family:宋体\">的</span><span style=\"font-size:16px\">learning about language</span><span style=\"font-size: 16px;font-family:宋体\">中：</span> </p> <p>     <span style=\"font-size:16px\">“How can Linda&nbsp;recover&nbsp;from her illness in this room when it’s so dirty and&nbsp;____________? It &nbsp;will only make her worse,” said the doctor.</span> </p> <p>     <span style=\"font-size:16px\">&nbsp;</span> </p> <p>     <span style=\"font-size:16px\">recover</span><span style=\"font-size:16px;font-family:宋体\">最常见的释义是</span><span style=\"font-size:16px\">“</span><span style=\"font-size:16px;font-family:宋体\">恢复健康</span><span style=\"font-size:16px\">”</span><span style=\"font-size:16px;font-family: 宋体\">，但高考中也出现过其他的释义，那如何记忆呢？其实，</span><span style=\"font-size:16px\">recover</span><span style=\"font-size:16px;font-family:宋体\">的基本义是</span><span style=\"font-size:16px\">“</span><span style=\"font-size:16px;font-family: 宋体\">重新获得</span><span style=\"font-size: 16px\"> (get again)”</span><span style=\"font-size:16px;font-family:宋体\">，结合不同的语境，因</span><span style=\"font-size:16px\">“</span><span style=\"font-size:16px;font-family: 宋体\">重新获得</span><span style=\"font-size: 16px\">”</span><span style=\"font-size:16px;font-family:宋体\">的事物不同，又衍生出了不同的释义。</span> </p> <p style=\"text-align: center;\">     <img src=\"http://source.weicistudy.com/web/images/18.jpg\"/> </p> <p style=\"text-align: center;\">     <img src=\"http://source.weicistudy.com/web/images/19.jpg\"/> </p> <ul class=\" list-paddingleft-2\" style=\"list-style-type: disc;\">     <li>         <p>             <span style=\"font-size:16px;font-family:宋体\">释义</span><span style=\"font-size:16px;font-family:&#39;Calibri&#39;,sans-serif\">◆</span><span style=\"font-size:16px;font-family: 宋体\">平时学习中不容易接触到，需特别留意；</span>         </p>     </li>     <li>         <p>             <span style=\"font-size:16px;font-family:宋体\">释义“恢复</span><span style=\"font-size:16px;font-family:&#39;Calibri&#39;,sans-serif\">&nbsp;(</span><span style=\"font-size:16px;font-family:宋体\">健康、常态</span><span style=\"font-size:16px;font-family:&#39;Calibri&#39;,sans-serif\">)</span><span style=\"font-size:16px;font-family: 宋体\">”是不及物动词，表示从……中恢复过来要和介词</span><span style=\"font-size:16px;font-family:&#39;Calibri&#39;,sans-serif\">from</span><span style=\"font-size:16px;font-family:宋体\">搭配，即</span><span style=\"font-size:16px;font-family:&#39;Calibri&#39;,sans-serif\">&nbsp;recover from sth</span><span style=\"font-size: 16px;\"><font face=\"宋体\">；</font></span>         </p>     </li>     <li>         <p>             <span style=\"font-size: 16px;\"><font face=\"宋体\"><span style=\"font-size:16px;font-family: &#39;Calibri&#39;,sans-serif\">recover</span><span style=\"font-size:16px;font-family:宋体\">常在高考阅读理解、完形填空和书面表达中出现；还常在完形填空中作为干扰项出现，是完形词汇。</span></font></span>         </p>     </li> </ul> <p>     <strong><span style=\"font-size:16px;font-family:宋体;color:#0070C0\">小贴士：</span></strong> </p> <p>     <span style=\"font-size:16px;font-family:宋体\">●</span><span style=\"font-size:16px\">&nbsp;</span><span style=\"font-size:16px;font-family:宋体\">在日常交际用语中，表示某人从重大疾病、受伤或手术中恢复健康时，更常用</span><span style=\"font-size:16px\">“get better”</span><span style=\"font-size: 16px;font-family:宋体\">。这是因为</span><span style=\"font-size:16px\">recover</span><span style=\"font-size:16px;font-family:宋体\">是一个学术词汇</span><span style=\"font-size:16px\"> (Academic Words</span><span style=\"font-size:16px;font-family:宋体\">，简称</span><span style=\"font-size:16px\">AW</span><span style=\"font-size:16px;font-family: 宋体\">，常出现在高考科普类等阅读篇章中。</span> </p> <p>     <strong><span style=\"font-size:16px;font-family:宋体;color:#0070C0\">词汇拓展：</span></strong> </p> <p style=\"text-align: center;\">     <span style=\"font-size: 16px;\"><font face=\"宋体\"><img src=\"http://source.weicistudy.com/web/images/20.jpg\"/></font></span><br/> </p> <p>     <span style=\"font-size: 16px;\"><font face=\"宋体\"></font></span> </p> <p>     <strong><span style=\"font-size:16px;font-family:宋体;color:#0070C0\">学后检测：</span></strong> </p> <p>     <span style=\"font-size:16px;font-family:宋体\">一、写出下列句子中</span><span style=\"font-size:16px\">recover</span><span style=\"font-size:16px;font-family:宋体\">的汉语释义。</span> </p> <p>     <span style=\"font-size:16px\">1.&nbsp;Once the damage is done, it will take many years for the farmland to&nbsp;recover.&nbsp;(2015&nbsp;</span><span style=\"font-size:16px;font-family:宋体\">北京</span><span style=\"font-size:16px\">)</span> </p> <p>     <span style=\"font-size:16px\">2.&nbsp;When a Swedish ship that sank in 1628 was&nbsp;recovered&nbsp;from the port of Stockholm, historians and scientists were overjoyed.&nbsp;(2006&nbsp;</span><span style=\"font-size:16px;font-family:宋体\">重庆</span><span style=\"font-size:16px\">)</span> </p> <p>     <span style=\"font-size:16px\">3.&nbsp;Once she nearly slipped (</span><span style=\"font-size:16px;font-family:宋体\">滑到</span><span style=\"font-size:16px\">), but somehow she&nbsp;recovered&nbsp;her balance and carried on running.</span> </p> <p>     <span style=\"font-size:16px\">&nbsp;</span> </p> <p>     <span style=\"font-size:16px;font-family:宋体\">二、将下列句子译成英语。</span> </p> <p>     <span style=\"font-size:16px\">1.&nbsp;</span><span style=\"font-size:16px;font-family:宋体\">要有充足的睡眠，这会帮助我们的眼睛从疲劳中恢复过来。</span><span style=\"font-size:16px\">(2007&nbsp;</span><span style=\"font-size: 16px;font-family:宋体\">天津书面表达</span><span style=\"font-size:16px\">)</span> </p> <p>     <span style=\"font-size:16px\">2.&nbsp;</span><span style=\"font-size:16px;font-family:宋体\">在我的精心照料下，我妈妈迅速恢复了健康。</span><span style=\"font-size:16px\">(2013&nbsp;</span><span style=\"font-size: 16px;font-family:宋体\">北京书面表达</span><span style=\"font-size:16px\">)</span> </p> <p>     <span style=\"font-size:16px\">&nbsp;</span> </p> <p>     <span style=\"font-size:16px;font-family:宋体;color:gray\">参考答案：</span> </p> <p>     <span style=\"font-size:16px;font-family:宋体;color:gray\">一、</span> </p> <p>     <span style=\"font-size:16px;color:gray\">1.&nbsp;</span><span style=\"font-size:16px;font-family:宋体;color:gray\">恢复常态</span><span style=\"font-size:16px;color:gray\"> &nbsp;&nbsp;2.&nbsp;</span><span style=\"font-size:16px;font-family:宋体;color:gray\">重新获得</span><span style=\"font-size:16px;color:gray\"> &nbsp;&nbsp;3.&nbsp;</span><span style=\"font-size:16px;font-family:宋体;color:gray\">恢复</span> </p> <p>     <span style=\"font-size:16px;font-family:宋体;color:gray\">二、</span> </p> <p>     <span style=\"font-size:16px;color:gray\">1. Have enough sleep, which will help our eyes recover from tiredness. &nbsp;&nbsp;&nbsp;</span> </p> <p>     <span style=\"font-size:16px;color:gray\">2.&nbsp;With my special care, my mother recovered quickly.</span> </p> <p>     <br/> </p>"},{"id":5,"title":"人教版 B1U3  prefer","date":"2017-04-12 13:25:45","img_url":"../../../static/images/cz3.png","desc":"我喜欢面条远胜过米饭，比起乘公交我更喜欢坐地铁。 你知道这两句话用英文怎么说吗？学会今天这个词，分分钟让你搞定它们。","content":"<p style=\"text-align: center;\">     <img src=\"http://source.weicistudy.com/web/images/21.jpg\"/> </p> <p style=\"text-align: center;\">     <img src=\"http://source.weicistudy.com/web/images/22.jpg\"/> </p> <p>     <strong><span style=\"font-size:16px;font-family:宋体;color:blue\">我喜欢面条远胜过米饭，比起乘公交我更喜欢坐地铁。</span></strong><span style=\"font-size:16px\">&nbsp;</span><span style=\"font-size:16px;font-family: 宋体\">你知道这两句话用英文怎么说吗？学会今天这个词，分分钟让你搞定它们。</span> </p> <p>     <span style=\"font-size:16px;font-family: 宋体\"><br/></span> </p> <p style=\"text-align: center;\">     <span style=\"font-size: 24px; background-color: rgb(255, 255, 255);\"><strong>prefer</strong></span> </p> <p></p> <p>     <strong><span style=\"font-size:16px;font-family:宋体;color:#0070C0;background:#D9D9D9\">教学建议</span></strong> </p> <p>     <br/> </p> <p>     <span style=\"font-size:16px;font-family:宋体\">掌握重点用法</span><span style=\"font-size:16px\">prefer sb / sth to do sth, prefer to do sth / doing sth, prefer (doing) sth to (doing) sth, prefer + that </span><span style=\"font-size:16px;font-family:宋体\">从句。</span> </p> <p>     <span style=\"font-size:16px\">prefer</span><span style=\"font-size:16px;font-family:宋体\">释义、用法和搭配</span> </p> <p style=\"text-align: center;\">     <span style=\"font-size: 24px; background-color: rgb(255, 255, 255);\"><strong><img src=\"http://source.weicistudy.com/web/images/23.jpg\"/></strong></span><br/> </p> <p>     <strong><span style=\"font-size:16px;font-family:宋体;color:#0070C0;background:#D9D9D9\">拓展</span></strong> </p> <p style=\"text-align: center;\">     <img src=\"http://source.weicistudy.com/web/images/24.png\"/> </p> <p>     <strong><span style=\"font-family:宋体;color:#0070C0;background:#D9D9D9;font-weight: normal\">备考指导</span></strong> </p> <p style=\"text-align: center;\">     <img src=\"http://source.weicistudy.com/web/images/25.jpg\"/> </p> <p>     <strong><span style=\"font-size:16px;font-family:宋体;color:#0070C0;background:#D9D9D9\">练习题</span></strong> </p> <p>     <span style=\"font-size:16px;font-family:宋体\">一、用所给单词的正确形式填空。</span> </p> <p>     <span style=\"font-size:16px\">1. I’d prefer _____________ (reserve) my judgment until I find all the evidence.</span> </p> <p>     <span style=\"font-size:16px\">2. I prefer my English classes _____________ (teach) in English only.</span> </p> <p>     <span style=\"font-size:16px\">3. I prefer going out for a more active life on Sundays to _____________ (stay) at home all day.</span> </p> <p>     <span style=\"font-size:16px;font-family:宋体\">二、根据所给提示，完成下列句子。</span> </p> <p>     <span style=\"font-size:16px\">1. Some people________________________________ (</span><span style=\"font-size:16px;font-family:宋体\">喜欢散步多于喜欢爬山</span><span style=\"font-size:16px\">).</span> </p> <p>     <span style=\"font-size:16px\">2. My parents_________________________________ (</span><span style=\"font-size:16px;font-family:宋体\">更喜欢早起</span><span style=\"font-size:16px\">) in the morning. (2014 </span><span style=\"font-size: 16px;font-family:宋体\">四川阅读</span><span style=\"font-size:16px\">)</span> </p> <p>     <span style=\"font-size:16px\">&nbsp;</span> </p> <p>     <span style=\"font-size:16px\">&nbsp;</span> </p> <p>     <span style=\"font-size:16px;font-family:宋体\">参考答案：</span> </p> <p>     <span style=\"font-size:16px;font-family:宋体\">一、</span><span style=\"font-size:16px\">1. reserving / to reserve &nbsp;&nbsp;2. to be taught &nbsp;&nbsp;3. staying</span> </p> <p>     <span style=\"font-size:16px;font-family:宋体\">二、</span><span style=\"font-size:16px\">1. prefer walking to climbing &nbsp;&nbsp;&nbsp;&nbsp;2. prefer getting up / to get up early</span> </p> <p>     <span style=\"font-size:16px\">&nbsp;</span> </p> <p>     <span style=\"font-size:16px\">&nbsp;</span> </p> <p>     <span style=\"font-size:16px;font-family:宋体\">文章开头的两句话你会说了吗？现在揭晓答案：</span><span style=\"font-size:16px\">I prefer noodles to rice.&nbsp;I prefer taking the subway to taking the bus.&nbsp;</span><span style=\"font-size:16px;font-family:宋体\">现在是不是觉得很</span><span style=\"font-size:16px\">easy</span><span style=\"font-size:16px;font-family: 宋体\">？</span> </p> <p>     <br/> </p>"},{"id":6,"title":"人教版 B1U3  view","date":"2017-04-15 13:25:45","img_url":"../../../static/images/cz3.png","desc":"view释义多，用法和搭配也相当多。想嚼透这个词，就先要弄清楚view作名词的几个释义。","content":"<p style=\"text-align: center;\">     <img src=\"http://source.weicistudy.com/web/images/26.png\"/> </p> <p>     <span style=\"font-size:16px;font-family:宋体\">高频多义词</span><span style=\"font-size:16px\">view</span><span style=\"font-size:16px;font-family:宋体\">出现在人教版教材模块一第三单元的</span><span style=\"font-size:16px\">Using Language</span><span style=\"font-size:16px;font-family:宋体\">中：</span> </p> <p>     <span style=\"font-size:16px\">To climb the mountains was hard work but as we looked around us, we were surprised by the <strong><span style=\"color:red\">view</span></strong></span>. </p> <p>     &nbsp; &nbsp; &nbsp;&nbsp; </p> <p>     <strong><span style=\"font-size:16px;color:red\">view</span></strong><span style=\"font-size:16px;font-family:宋体\">释义多，用法和搭配也相当多。想嚼透这个词，就先要弄清楚</span><strong><span style=\"font-size:16px;color:red\">view</span></strong><span style=\"font-size:16px;font-family:宋体\">作名词的几个释义。</span> </p> <p style=\"text-align: center;\">     <img src=\"http://source.weicistudy.com/web/images/27.jpg\"/> </p> <p>     <span style=\"font-size:16px;font-family:宋体;color:#0070C0\">◆</span> <span style=\"font-size:16px;font-family:宋体;color:#0070C0\">研究词源后不难发现，</span><span style=\"font-size:16px;color:#0070C0\">view</span><span style=\"font-size:16px;font-family:宋体;color:#0070C0\">名词的词源义“</span><span style=\"font-size:16px;color:#0070C0\">(</span><span style=\"font-size:16px;font-family:宋体;color:#0070C0\">对土地的</span><span style=\"font-size:16px;color:#0070C0\">) </span><span style=\"font-size:16px;font-family:宋体;color:#0070C0\">正式视察”已经消失；而</span><span style=\"font-size:16px;color:#0070C0\">15</span><span style=\"font-size:16px;font-family:宋体;color:#0070C0\">世纪中期产生的意义“视觉”是它的基本义。这一意义源自于拉丁语</span><span style=\"font-size:16px;color:#0070C0\">videre&nbsp;(to see)</span><span style=\"font-size:16px;font-family:宋体;color:#0070C0\">，和英语</span><span style=\"font-size:16px;color:#0070C0\">vision</span><span style=\"font-size:16px;font-family:宋体;color:#0070C0\">是同根词。</span> </p> <p>     <span style=\"font-size:16px;font-family:宋体;color:#0070C0\">◆</span><span style=\"font-size:16px;color:#0070C0\"> view</span><span style=\"font-size:16px;font-family:宋体;color:#0070C0\">根据基本义“视觉；视野；视线”，结合不同的语境又衍生出新的释义。</span> </p> <p style=\"margin-bottom: 14px;line-height: 16px;background: white\">     <span style=\"font-size: 0;font-family: 宋体\">原创 <em>2016-10-11</em> <em>维克多英语</em> <a href=\"https://mp.weixin.qq.com/s?__biz=MjM5ODA3OTQwMg==&mid=2649442239&idx=1&sn=c6307872e986ba8a009befb663374174&chksm=becfd97a89b8506cbca8ed63cca5474b7e040c5f5f2ca0948908dbb93b7b561e8dd55099b530&mpshare=1&srcid=071356EG3UiXEBTZNCg46XYk&scene=21&key=df6ffc53afecec0ccc31926480b5c601290bc23205fc6538eb46cfd13e4db46e18a3216ea6af41c71c1bfdc6cd8bfdf87f1467e7278e3717ab50319941bea514c3b82a05d49a6ef812b8f35419ff9fd2&ascene=0&uin=MTc4OTQ1Mjk4Mg==&devicetype=uwppc&version=c10202ff&pass_ticket=Y+mIRjWg4kr7b4dHyQYbDQCHOkL4DcH61MlLLKR8AsMjCbAK20KcDY4sbejxI3Ef##\">维克多英语</a> 维克多英</span> </p> <p style=\"text-align: center;\">     <img src=\"http://source.weicistudy.com/web/images/28.jpg\"/> </p> <p style=\"text-align: center;\">     <img src=\"http://source.weicistudy.com/web/images/29.jpg\"/> </p> <p style=\"text-align: center;\">     <img src=\"http://source.weicistudy.com/web/images/30.jpg\"/> </p> <ul class=\" list-paddingleft-2\" style=\"list-style-type: disc;\">     <li>         <p>             <span style=\"font-size:16px;color:#0070C0\">&nbsp;</span><span style=\"font-size:16px;font-family:宋体;color:#0070C0\">释义</span><span style=\"font-size:16px;color:#0070C0\"><img width=\"21\" height=\"21\" src=\"/vue2-management-platform/static/UE/themes/default/images/spacer.gif\" alt=\"IMG_260\" word_img=\"file:///C:/Users/gaolong/AppData/Local/Temp/msohtmlclip1/01/clip_image002.gif\" style=\"background:url(/vue2-management-platform/static/UE/themes/default/images/word.gif) no-repeat center center;border:1px solid #ddd\"/></span><span style=\"font-size: 16px;font-family:宋体;color:#0070C0\">比较抽象不好理解，可通过英语释义和例句帮助加深理解；</span>         </p>     </li>     <li>         <p>             <span style=\"font-size:16px;font-family:宋体;color:#0070C0\">理解</span><span style=\"font-size:16px;font-family:&#39;Calibri&#39;,sans-serif;color:#0070C0\">view</span><span style=\"font-size:16px;font-family:宋体;color:#0070C0\">的释义后，还要牢记各释义下的常见搭配：</span><span style=\"font-size:16px;font-family:&#39;Calibri&#39;,sans-serif;color:#0070C0\">in view, come into view,&nbsp;</span><span style=\"font-size:16px;font-family: &#39;Calibri&#39;,sans-serif;color:#0070C0\">block sb’s view; views on / about; in sb’s view; from sb’s point of view</span><span style=\"font-size: 16px; color: rgb(0, 112, 192);\"><font face=\"宋体\">；</font></span>         </p>     </li>     <li>         <p>             <span style=\"font-size: 16px; color: rgb(0, 112, 192);\"><font face=\"宋体\"><span style=\"font-size:16px;font-family: &#39;Calibri&#39;,sans-serif;color:#0070C0\">in sb’s view</span><span style=\"font-size:16px;font-family:宋体;color:#0070C0\">和</span><span style=\"font-size:16px;font-family:&#39;Calibri&#39;,sans-serif;color:#0070C0\">from sb’s point of view</span><span style=\"font-size:16px;font-family:宋体;color:#0070C0\">是高考写作常用词块；</span></font></span>         </p>     </li>     <li>         <p>             <span style=\"font-size: 16px; color: rgb(0, 112, 192);\"><font face=\"宋体\"><span style=\"font-size:16px;font-family:宋体;color:#0070C0\"><span style=\"font-size:16px;font-family:宋体;color:#0070C0\">重要固定搭配</span><span style=\"font-size: 16px;font-family:&#39;Calibri&#39;,sans-serif;color:#0070C0\">in view of</span><span style=\"font-size:16px;font-family:宋体;color:#0070C0\">和</span><span style=\"font-size:16px;font-family:&#39;Calibri&#39;,sans-serif;color:#0070C0\">on view</span><span style=\"font-size:16px;font-family:宋体;color:#0070C0\">也要牢记释义和用法；</span></span></font></span>         </p>     </li> </ul> <p style=\"text-align: center;\">     <span style=\"font-size: 16px; color: rgb(0, 112, 192);\"><font face=\"宋体\"><span style=\"font-size:16px;font-family:宋体;color:#0070C0\"><span style=\"font-size:16px;font-family:宋体;color:#0070C0\"><img src=\"http://source.weicistudy.com/web/images/31.jpg\"/></span></span></font></span><br/> </p> <ul class=\" list-paddingleft-2\" style=\"list-style-type: disc;\">     <li>         <p>             <span style=\"font-size: 16px; color: rgb(0, 112, 192);\"><font face=\"宋体\"><span style=\"font-size:16px;font-family:宋体;color:#0070C0\"><span style=\"font-size:16px;font-family:宋体;color:#0070C0\"><span style=\"font-size:16px;font-family:宋体;color:#0070C0\">掌握了</span><span style=\"font-size: 16px;font-family:&#39;Calibri&#39;,sans-serif;color:#0070C0\">view</span><span style=\"font-size:16px;font-family:宋体;color:#0070C0\">的名词释义后，可相应理解和掌握它的动词释义。</span></span></span></font></span>         </p>     </li> </ul> <p>     <span style=\"font-size: 16px; color: rgb(0, 112, 192);\"><font face=\"宋体\"><span style=\"font-size:16px;font-family:宋体;color:#0070C0\"><span style=\"font-size:16px;font-family:宋体;color:#0070C0\"><br/></span></span></font></span> </p> <p>     <strong><span style=\"font-size:19px;font-family:宋体;color:#0070C0\">学后检测</span></strong> </p> <p>     <strong><span style=\"font-size:16px;font-family:宋体\">一、写出下列句子中</span></strong><strong><span style=\"font-size:16px\">view</span></strong><strong><span style=\"font-size: 16px;font-family:宋体\">的汉语释义。</span></strong> </p> <p>     <span style=\"font-size:16px\">1. I got a place next&nbsp;to the window, so I had a good view&nbsp;of the sidewalk.&nbsp;(2014 </span><span style=\"font-size:16px;font-family:宋体\">全国</span><span style=\"font-size:16px\">)</span> </p> <p>     <span style=\"font-size:16px\">2. Do you agree with the grandfather’s view&nbsp;on life? (2015 </span><span style=\"font-size: 16px;font-family:宋体\">天津</span><span style=\"font-size:16px\">)&nbsp;&nbsp;&nbsp;</span> </p> <p>     <span style=\"font-size:16px\">3. Silence may be viewed&nbsp;by some cultural groups as extremely uncomfortable. (2016 </span><span style=\"font-size:16px;font-family:宋体\">全国</span><span style=\"font-size:16px\">)</span> </p> <p>     <span style=\"font-size:16px\">4. On these sites, a student can view&nbsp;numerous photos and art pieces from different mediums. (2011 </span><span style=\"font-size:16px;font-family:宋体\">湖南</span><span style=\"font-size:16px\">)</span> </p> <p>     <span style=\"font-size:16px\">5. If we go on a trip abroad, we can broaden our view&nbsp;and gain knowledge we cannot get from books. (2016 </span><span style=\"font-size:16px;font-family:宋体\">全国</span><span style=\"font-size:16px\">) &nbsp;&nbsp;&nbsp;</span> </p> <p>     <strong><span style=\"font-size:16px;font-family:宋体\">二、写出下列短语的英语形式。</span></strong> </p> <p>     <span style=\"font-size:16px\">1. </span><span style=\"font-size:16px;font-family:宋体\">挡住视线</span> </p> <p>     <span style=\"font-size:16px\">2. </span><span style=\"font-size:16px;font-family:宋体\">映入眼帘</span> </p> <p>     <span style=\"font-size:16px\">3. </span><span style=\"font-size:16px;font-family:宋体\">人生观</span> </p> <p>     <span style=\"font-size:16px\">4. </span><span style=\"font-size:16px;font-family:宋体\">鉴于；考虑到</span> </p> <p>     <strong><span style=\"font-size:16px;font-family:宋体\">三、将下列句子译成英语。</span></strong> </p> <p>     <span style=\"font-size:16px\">1. </span><span style=\"font-size:16px;font-family:宋体\">就我个人而言，我赞同第二种观点。</span> </p> <p>     <span style=\"font-size:16px\">2. </span><span style=\"font-size:16px;font-family:宋体\">爬山时，我们沐浴着温暖的阳光，欣赏着美丽的风景。</span> </p> <p>     <span style=\"font-size:16px\">3. </span><span style=\"font-size:16px;font-family:宋体\">在我看来，人和人之间没有什么差别。</span> </p> <p>     <span style=\"font-size:16px\">&nbsp;</span> </p> <p>     <span style=\"font-size:16px;font-family:宋体;color:gray\">参考答案：</span> </p> <p>     <span style=\"font-size:16px;font-family:宋体;color:gray\">一、</span> </p> <p>     <span style=\"font-size:16px;color:gray\">1. </span><span style=\"font-size:16px;font-family:宋体;color:gray\">视野；视线</span><span style=\"font-size:16px;color:gray\"> &nbsp;2. </span><span style=\"font-size:16px;font-family: 宋体;color:gray\">观点</span><span style=\"font-size:16px;color:gray\"> &nbsp;3. </span><span style=\"font-size:16px;font-family:宋体;color:gray\">视作</span><span style=\"font-size:16px;color:gray\"> &nbsp;4. </span><span style=\"font-size:16px;font-family: 宋体;color:gray\">看；观看</span><span style=\"font-size:16px;color:gray\"> &nbsp;5. </span><span style=\"font-size:16px;font-family:宋体;color:gray\">眼界</span> </p> <p>     <span style=\"font-size:16px;font-family:宋体;color:gray\">二、</span> </p> <p>     <span style=\"font-size:16px;color:gray\">1. block sb’s view &nbsp;&nbsp;2. come into view &nbsp;3. view of life &nbsp;4. in view of </span> </p> <p>     <span style=\"font-size:16px;font-family:宋体;color:gray\">三、</span> </p> <p>     <span style=\"font-size:16px;color:gray\">1. Personally, I agree with the second view. &nbsp;</span> </p> <p>     <span style=\"font-size:16px;color:gray\">2.&nbsp;While climbing the mountain, we enjoyed the warm sunshine and a beautiful view. &nbsp;&nbsp;</span> </p> <p>     <span style=\"font-size:16px;color:gray\">3. From my point of view&nbsp;/ In my view, there is no difference between one person and another.&nbsp;</span> </p> <p>     <br/> </p>"}]}

/***/ }),
/* 17 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue_router__ = __webpack_require__(95);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__pages_Index__ = __webpack_require__(72);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__pages_Index___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__pages_Index__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__pages_Junior__ = __webpack_require__(73);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__pages_Junior___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__pages_Junior__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__pages_About__ = __webpack_require__(66);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__pages_About___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__pages_About__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__pages_Download__ = __webpack_require__(71);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__pages_Download___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5__pages_Download__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__pages_Discovery_Index__ = __webpack_require__(69);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__pages_Discovery_Index___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6__pages_Discovery_Index__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__pages_Discovery_ClassDetail__ = __webpack_require__(68);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__pages_Discovery_ClassDetail___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7__pages_Discovery_ClassDetail__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__pages_Discovery_ArticleDetail__ = __webpack_require__(67);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__pages_Discovery_ArticleDetail___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8__pages_Discovery_ArticleDetail__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__pages_Discovery_ListenDetail__ = __webpack_require__(70);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__pages_Discovery_ListenDetail___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9__pages_Discovery_ListenDetail__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__pages_Teacher__ = __webpack_require__(75);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__pages_Teacher___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_10__pages_Teacher__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__pages_Teachercz__ = __webpack_require__(76);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__pages_Teachercz___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_11__pages_Teachercz__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__pages_Messages__ = __webpack_require__(74);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__pages_Messages___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_12__pages_Messages__);














__WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].use(__WEBPACK_IMPORTED_MODULE_1_vue_router__["a" /* default */]);

/* harmony default export */ __webpack_exports__["a"] = (new __WEBPACK_IMPORTED_MODULE_1_vue_router__["a" /* default */]({
  routes: [{
    path: '/',
    name: 'Teacher',
    component: __WEBPACK_IMPORTED_MODULE_10__pages_Teacher___default.a
  }, {
    path: '/student',
    name: 'Index',
    component: __WEBPACK_IMPORTED_MODULE_2__pages_Index___default.a
  }, {
    path: '/download',
    name: 'Download',
    component: __WEBPACK_IMPORTED_MODULE_5__pages_Download___default.a
  }, {
    path: '/junior',
    name: 'Junior',
    component: __WEBPACK_IMPORTED_MODULE_3__pages_Junior___default.a
  }, {
    path: '/teachercz',
    name: 'Teachercz',
    component: __WEBPACK_IMPORTED_MODULE_11__pages_Teachercz___default.a
  }, {
    path: '/about',
    name: 'About',
    component: __WEBPACK_IMPORTED_MODULE_4__pages_About___default.a
  }, {
    path: '/discovery',
    name: 'Discovery',
    component: __WEBPACK_IMPORTED_MODULE_6__pages_Discovery_Index___default.a
  }, {
    path: '/discovery/class/:id',
    name: 'ClassDetail',
    component: __WEBPACK_IMPORTED_MODULE_7__pages_Discovery_ClassDetail___default.a
  }, {
    path: '/discovery/article/:id',
    name: 'ArticleDetail',
    component: __WEBPACK_IMPORTED_MODULE_8__pages_Discovery_ArticleDetail___default.a
  }, {
    path: '/discovery/listen/:id',
    name: 'ListenDetail',
    component: __WEBPACK_IMPORTED_MODULE_9__pages_Discovery_ListenDetail___default.a
  }, {
    path: '/message',
    name: 'Message',
    component: __WEBPACK_IMPORTED_MODULE_12__pages_Messages___default.a
  }]
}));

/***/ }),
/* 18 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vuex__ = __webpack_require__(97);



__WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].use(__WEBPACK_IMPORTED_MODULE_1_vuex__["a" /* default */]);

// const debug = process.env.NODE_ENV !== 'production'

/* harmony default export */ __webpack_exports__["a"] = (new __WEBPACK_IMPORTED_MODULE_1_vuex__["a" /* default */].Store({
  state: {
    count: 0
  },
  getters: {
    getCount: function getCount(state) {
      return state.count.toString() + '元';
    }
  },
  mutations: {
    increment: function increment(state) {
      state.count++;
      console.log(state.count);
    }
  }
}));

/***/ }),
/* 19 */,
/* 20 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(40)
}
var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(24),
  /* template */
  __webpack_require__(85),
  /* styles */
  injectStyle,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 21 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__App__ = __webpack_require__(20);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__App___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__App__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__router__ = __webpack_require__(17);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_vue_lazyload__ = __webpack_require__(19);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_vue_awesome_swiper__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_vue_awesome_swiper___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_vue_awesome_swiper__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__store__ = __webpack_require__(18);
// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.







__WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].config.productionTip = false;

__WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].use(__WEBPACK_IMPORTED_MODULE_3_vue_lazyload__["a" /* default */], {
  preLoad: 1.3,
  error: '/static/images/error.jpg',
  loading: '/static/images/loading.gif',
  attempt: 1
});

__WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].use(__WEBPACK_IMPORTED_MODULE_4_vue_awesome_swiper___default.a);

// 路由钩子
// router.beforeEach((to, from, next) => {
//   console.log(to)
//   next()
// })

/* eslint-disable no-new */
new __WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */]({
  el: '#app',
  router: __WEBPACK_IMPORTED_MODULE_2__router__["a" /* default */],
  store: __WEBPACK_IMPORTED_MODULE_5__store__["a" /* default */],
  template: '<App/>',
  components: { App: __WEBPACK_IMPORTED_MODULE_1__App___default.a }
});

/***/ }),
/* 22 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'swiper-slide',
  data: function data() {
    return {
      slideClass: 'swiper-slide'
    };
  },
  ready: function ready() {
    this.update();
  },
  mounted: function mounted() {
    this.update();
    if (this.$parent.options.slideClass) {
      this.slideClass = this.$parent.options.slideClass;
    }
  },
  updated: function updated() {
    this.update();
  },
  attached: function attached() {
    this.update();
  },
  methods: {
    update: function update() {
      if (this.$parent && this.$parent.swiper && this.$parent.swiper.update) {
        this.$parent.swiper.update(true);
        if (this.$parent.options.loop) {
          this.$parent.swiper.reLoop();
        }
      }
    }
  }
});

/***/ }),
/* 23 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
//
//
//
//
//
//
//
//
//
//
//
//
//

var browser = typeof window !== 'undefined';
if (browser) window.Swiper = __webpack_require__(13);
/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'swiper',
  props: {
    options: {
      type: Object,
      default: function _default() {
        return {
          autoplay: 3500
        };
      }
    },
    notNextTick: {
      type: Boolean,
      default: function _default() {
        return false;
      }
    }
  },
  data: function data() {
    return {
      defaultSwiperClasses: {
        wrapperClass: 'swiper-wrapper'
      }
    };
  },
  ready: function ready() {
    if (!this.swiper && browser) {
      this.swiper = new Swiper(this.$el, this.options);
    }
  },
  mounted: function mounted() {
    var self = this;
    var mount = function () {
      if (!self.swiper && browser) {
        delete self.options.notNextTick;
        var setClassName = false;
        for (var className in self.defaultSwiperClasses) {
          if (self.defaultSwiperClasses.hasOwnProperty(className)) {
            if (self.options[className]) {
              setClassName = true;
              self.defaultSwiperClasses[className] = self.options[className];
            }
          }
        }
        var mountInstance = function mountInstance() {
          self.swiper = new Swiper(self.$el, self.options);
        };
        setClassName ? self.$nextTick(mountInstance) : mountInstance();
      }
    }(this.options.notNextTick || this.notNextTick) ? mount() : this.$nextTick(mount);
  },
  updated: function updated() {
    if (this.swiper) {
      this.swiper.update();
    }
  },
  beforeDestroy: function beforeDestroy() {
    if (this.swiper) {
      this.swiper.destroy();
      delete this.swiper;
    }
  }
});

/***/ }),
/* 24 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'app',
  created: function created() {
    if (this.mobileCheck()) {
      window.location.href = 'http://www.weixuetec.com/mobile.html';
    }
  },

  methods: {
    mobileCheck: function mobileCheck() {
      var agent = navigator.userAgent || navigator.vendor || window.opera;
      console.log(agent);
      var Agents = ['Android', 'iPhone', 'SymbianOS', 'Windows Phone', 'iPad', 'iPod'];
      var flag = false;
      flag = Agents.every(function (element, index, array) {
        return !(agent.indexOf(element) > 0);
      });
      return !flag;
    }
  }
});

/***/ }),
/* 25 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["default"] = ({
  data: function data() {
    return {};
  }
});

/***/ }),
/* 26 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["default"] = ({
  data: function data() {
    return {
      menu: {
        home: true,
        junior: false,
        discovery: false,
        about: false,
        msg: false
      }
    };
  },

  props: ['menuName'],
  created: function created() {
    this.init();
  },
  methods: {
    init: function init() {
      switch (this.menuName) {
        case 'home':
          this.menu.home = true;
          this.menu.junior = false;
          this.menu.discovery = false;
          this.menu.about = false;
          this.menu.msg = false;
          break;
        case 'junior':
          this.menu.home = false;
          this.menu.junior = true;
          this.menu.discovery = false;
          this.menu.about = false;
          this.menu.msg = false;
          break;
        case 'discovery':
          this.menu.home = false;
          this.menu.junior = false;
          this.menu.discovery = true;
          this.menu.about = false;
          this.menu.msg = false;
          break;
        case 'about':
          this.menu.home = false;
          this.menu.junior = false;
          this.menu.discovery = false;
          this.menu.about = true;
          this.menu.msg = false;
          break;
        case 'msg':
          this.menu.home = false;
          this.menu.junior = false;
          this.menu.discovery = false;
          this.menu.about = false;
          this.menu.msg = true;
          break;
        default:
          break;
      }
    }
  }
});

/***/ }),
/* 27 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_Footer__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_Footer___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__components_Footer__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_Menu__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_Menu___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__components_Menu__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__assets_data_position__ = __webpack_require__(99);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__assets_data_position___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__assets_data_position__);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//





/* harmony default export */ __webpack_exports__["default"] = ({
  data: function data() {
    return {
      positions: [],
      all: true,
      product: false,
      technology: false,
      design: false,
      operation: false
    };
  },
  created: function created() {
    this.positions = __WEBPACK_IMPORTED_MODULE_2__assets_data_position___default.a.positions;
  },

  components: {
    MyFooter: __WEBPACK_IMPORTED_MODULE_0__components_Footer___default.a,
    MyMenu: __WEBPACK_IMPORTED_MODULE_1__components_Menu___default.a
  },
  methods: {
    clickHandler: function clickHandler(e) {
      var cate = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 'all';

      if (cate === 'all') {
        this.positions = __WEBPACK_IMPORTED_MODULE_2__assets_data_position___default.a.positions;
        this.all = true;
      } else {
        this.positions = __WEBPACK_IMPORTED_MODULE_2__assets_data_position___default.a.positions.filter(function (value) {
          return value.category === cate;
        });
      }

      this.reset(cate);
    },
    reset: function reset(cate) {
      this.all = false;
      this.product = false;
      this.technology = false;
      this.design = false;
      this.operation = false;
      switch (cate) {
        case 'all':
          this.all = true;
          break;
        case 'product':
          this.product = true;
          break;
        case 'technology':
          this.technology = true;
          break;
        case 'design':
          this.design = true;
          break;
        case 'operation':
          this.operation = true;
          break;
        default:
          this.all = true;
          break;
      }
    }
  }
});

/***/ }),
/* 28 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_Footer__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_Footer___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__components_Footer__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_Menu__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_Menu___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__components_Menu__);
//
//
//
//
//
//
//
//



/* harmony default export */ __webpack_exports__["default"] = ({
  data: function data() {
    return {};
  },

  components: {
    MyFooter: __WEBPACK_IMPORTED_MODULE_0__components_Footer___default.a,
    MyMenu: __WEBPACK_IMPORTED_MODULE_1__components_Menu___default.a
  }
});

/***/ }),
/* 29 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_Footer__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_Footer___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__components_Footer__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_Menu__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_Menu___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__components_Menu__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__assets_data_classes__ = __webpack_require__(16);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__assets_data_classes___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__assets_data_classes__);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//





/* harmony default export */ __webpack_exports__["default"] = ({
  data: function data() {
    return {
      id: 0,
      class_detail: {},
      topRight: 0
    };
  },

  components: {
    MyFooter: __WEBPACK_IMPORTED_MODULE_0__components_Footer___default.a,
    MyMenu: __WEBPACK_IMPORTED_MODULE_1__components_Menu___default.a
  },
  created: function created() {
    var vm = this;
    vm.id = vm.$route.params.id;
    if (typeof __WEBPACK_IMPORTED_MODULE_2__assets_data_classes___default.a.classes !== 'undefined') {
      vm.class_detail = __WEBPACK_IMPORTED_MODULE_2__assets_data_classes___default.a.classes.find(function (ele) {
        return parseInt(vm.id) === ele.id;
      });
    }

    this.init();
  },

  watch: {
    $route: function $route() {
      var vm = this;
      vm.id = vm.$route.params.id;
      if (typeof __WEBPACK_IMPORTED_MODULE_2__assets_data_classes___default.a.classes !== 'undefined') {
        vm.class_detail = __WEBPACK_IMPORTED_MODULE_2__assets_data_classes___default.a.classes.find(function (ele) {
          return parseInt(vm.id) === ele.id;
        });
      }
    }
  },
  methods: {
    init: function init() {
      var vm = this;
      var wWidth = document.documentElement.clientWidth || document.body.clientWidth;
      // let wHeight = document.documentElement.clientHeight || document.body.clientHeight

      vm.topRight = Math.round((wWidth - 1000) / 2) - 48;
    },
    goTop: function goTop() {
      console.log(document.documentElement.scrollTop || document.body.scrollTop);
      console.log(window);
      document.documentElement.scrollTop = 0;
      document.body.scrollTop = 0;
    }
  }
});

/***/ }),
/* 30 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_Footer__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_Footer___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__components_Footer__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_Menu__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_Menu___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__components_Menu__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vue_awesome_swiper__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vue_awesome_swiper___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_vue_awesome_swiper__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__assets_data_classes__ = __webpack_require__(16);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__assets_data_classes___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__assets_data_classes__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__assets_data_articles__ = __webpack_require__(98);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__assets_data_articles___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__assets_data_articles__);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//








/* harmony default export */ __webpack_exports__["default"] = ({
  data: function data() {
    return {
      swiperOption: {
        autoplay: 1000,
        // direction: 'vertical',
        autoHeight: true,
        pagination: '.swiper-pagination',
        prevButton: '.swiper-button-prev',
        nextButton: '.swiper-button-next'
      },
      swiperOption2: {},
      audio: {
        music: false,
        listen: true
      },
      classes: [],
      articles: []
    };
  },

  components: {
    MyFooter: __WEBPACK_IMPORTED_MODULE_0__components_Footer___default.a,
    MyMenu: __WEBPACK_IMPORTED_MODULE_1__components_Menu___default.a,
    swiper: __WEBPACK_IMPORTED_MODULE_2_vue_awesome_swiper__["swiper"],
    swiperSlide: __WEBPACK_IMPORTED_MODULE_2_vue_awesome_swiper__["swiperSlide"]
  },
  created: function created() {
    if (typeof __WEBPACK_IMPORTED_MODULE_3__assets_data_classes___default.a.classes !== 'undefined') {
      this.classes = __WEBPACK_IMPORTED_MODULE_3__assets_data_classes___default.a.classes.slice(0, 4);
    }

    if (typeof __WEBPACK_IMPORTED_MODULE_4__assets_data_articles___default.a.articles !== 'undefined') {
      this.articles = __WEBPACK_IMPORTED_MODULE_4__assets_data_articles___default.a.articles.slice(0, 6);
    }
  },

  computed: {
    swiper1: function swiper1() {
      return this.$refs.swiper1.swiper;
    },
    swiper2: function swiper2() {
      return this.$refs.swiper2.swiper;
    }
  },
  methods: {
    rightSwiper: function rightSwiper() {
      if (this.swiper2.isEnd) this.swiper2.slideTo(0);else this.swiper2.slideNext();

      this.slideTo(this.swiper2.realIndex);
    },
    leftSwiper: function leftSwiper() {
      if (this.swiper2.isBeginning) this.swiper2.slideTo(this.swiper2.slides.length - 1);else this.swiper2.slidePrev();

      this.slideTo(this.swiper2.realIndex);
    },
    slideTo: function slideTo(index) {
      if (index === 0) {
        this.audio.listen = true;
        this.audio.music = false;
      } else {
        this.audio.listen = false;
        this.audio.music = true;
      }
      this.swiper2.slideTo(index);
    }
  }
});

/***/ }),
/* 31 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_Footer__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_Footer___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__components_Footer__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_Menu__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_Menu___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__components_Menu__);
//
//
//
//
//
//
//
//



/* harmony default export */ __webpack_exports__["default"] = ({
  data: function data() {
    return {};
  },

  components: {
    MyFooter: __WEBPACK_IMPORTED_MODULE_0__components_Footer___default.a,
    MyMenu: __WEBPACK_IMPORTED_MODULE_1__components_Menu___default.a
  }
});

/***/ }),
/* 32 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_Menu__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_Menu___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__components_Menu__);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//


/* harmony default export */ __webpack_exports__["default"] = ({
  data: function data() {
    return {};
  },

  components: {
    MyMenu: __WEBPACK_IMPORTED_MODULE_0__components_Menu___default.a
  }
});

/***/ }),
/* 33 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_Footer__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_Footer___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__components_Footer__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_Menu__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_Menu___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__components_Menu__);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//




/* harmony default export */ __webpack_exports__["default"] = ({
  data: function data() {
    return {};
  },

  components: {
    MyFooter: __WEBPACK_IMPORTED_MODULE_0__components_Footer___default.a,
    MyMenu: __WEBPACK_IMPORTED_MODULE_1__components_Menu___default.a
  },
  methods: {}
});

/***/ }),
/* 34 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_Footer__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_Footer___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__components_Footer__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_Menu__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_Menu___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__components_Menu__);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//




/* harmony default export */ __webpack_exports__["default"] = ({
  data: function data() {
    return {};
  },

  components: {
    MyFooter: __WEBPACK_IMPORTED_MODULE_0__components_Footer___default.a,
    MyMenu: __WEBPACK_IMPORTED_MODULE_1__components_Menu___default.a
  },
  created: function created() {}
});

/***/ }),
/* 35 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_Footer__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_Footer___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__components_Footer__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_Menu__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_Menu___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__components_Menu__);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'Messages',
  components: {
    MyFooter: __WEBPACK_IMPORTED_MODULE_0__components_Footer___default.a, MyMenu: __WEBPACK_IMPORTED_MODULE_1__components_Menu___default.a
  },
  data: function data() {
    return {
      dialogShow: false
    };
  },

  methods: {
    subHandle: function subHandle() {
      this.dialogShow = !this.dialogShow;
    },
    closeDialog: function closeDialog() {
      this.dialogShow = !this.dialogShow;
    }
  }
});

/***/ }),
/* 36 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_Footer__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_Footer___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__components_Footer__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_Menu__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_Menu___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__components_Menu__);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//




/* harmony default export */ __webpack_exports__["default"] = ({
  data: function data() {
    return {};
  },

  components: {
    MyFooter: __WEBPACK_IMPORTED_MODULE_0__components_Footer___default.a,
    MyMenu: __WEBPACK_IMPORTED_MODULE_1__components_Menu___default.a
  },
  methods: {}
});

/***/ }),
/* 37 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_Footer__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_Footer___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__components_Footer__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_Menu__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_Menu___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__components_Menu__);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//




/* harmony default export */ __webpack_exports__["default"] = ({
  data: function data() {
    return {};
  },

  components: {
    MyFooter: __WEBPACK_IMPORTED_MODULE_0__components_Footer___default.a,
    MyMenu: __WEBPACK_IMPORTED_MODULE_1__components_Menu___default.a
  },
  methods: {}
});

/***/ }),
/* 38 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 39 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 40 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 41 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 42 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 43 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 44 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 45 */,
/* 46 */,
/* 47 */,
/* 48 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/aheader.8537c10.png";

/***/ }),
/* 49 */
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,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"

/***/ }),
/* 50 */
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAADoAAABCCAMAAAAxFDW2AAAAilBMVEUAAAAzMzMzMzMzMzMzMzMzMzMzMzMzMzMzMzMzMzMzMzMzMzMzMzMzMzMzMzMzMzMzMzMzMzMzMzMzMzMzMzMzMzMzMzMzMzMzMzMzMzMzMzMzMzMzMzMzMzMzMzMzMzMzMzMzMzMzMzMzMzMzMzMzMzMzMzMzMzMzMzMzMzMzMzMzMzMzMzMzMzORiUCaAAAALXRSTlMA7h6laeLSS4g8EPrE3usI9S4ZBQGwq3LIupBWTygMwLaDXjQhoJd7JtpTQ4vIglgyAAABm0lEQVRIx+3WyW7CMBCA4WFJSO1m3whZ2PfO+79eLSZUKTjxHKqqqvgvGSM+4fiQAI/VDujaLcDcPgRN2Y5Bo1UCT1Vr4JRv6BqLXdTQ6C99Fo2XAsI8dSWqRvNF1YAzA16zpY3dgknBg3Hu4VPpiSFDG3XJPDFuNsCeUsNJlVKdjOu63T1LV6WuxaC9KomOGqYdaqm1uP3uwJ4jD4coHvtphsNU1n1yi7cWQoi8S9V6TGPWRydoSo71Ukg0ttbTCs296+kHg8q453wZ6W82HTEK4WcSC8tbbYFf47gEGhtV8gow4d2rP0dV8AZwpI/chEunNNgAc6RCLi3aaQdWO8241G6ntxd90Rf9bXq+T0zaeTZkNEjBpQcaAh+2kl5vwKV18PX2uYzUsI/ZFGaeuh5iUIlqUwPwKTTV5gSd2JT6C3TPoZGWbhjSTrQ0Me/YC0FfUjqOUyBVONShXVtqPkYw1BSpKVDjb39AXvS/0IhPS6RKoHxJ69RMo4CeWgLaVvddmMsfvlmPULWMgVE5994vnfUps85rH576BDVuYtuGRDUPAAAAAElFTkSuQmCC"

/***/ }),
/* 51 */
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAADoAAABCCAMAAAAxFDW2AAAAilBMVEUAAAAzMzMzMzMzMzMzMzMzMzMzMzMzMzMzMzMzMzMzMzMzMzMzMzMzMzMzMzMzMzMzMzMzMzMzMzMzMzMzMzMzMzMzMzMzMzMzMzMzMzMzMzMzMzMzMzMzMzMzMzMzMzMzMzMzMzMzMzMzMzMzMzMzMzMzMzMzMzMzMzMzMzMzMzMzMzMzMzMzMzORiUCaAAAALXRSTlMACgKSGQb8+XguE6d/7eHHmHBHEPPmvbiyoWpfUDgd29dLJdTMwpw9imZZM4j7pPvqAAABn0lEQVRIx+3WyXKCQBCA4WHfRASUHRTcoqbf//WSCDFOq6nuuaUq/8mDXw3KNIz4T0o/Ljalkkx2AFAowDQAUKPdFq69saW/hrGGK/VikkuNS2uYMrjSmk/S6ZQXnQlu+SQjiys1Z5RrU3DzRpnxpTheb0usk69yaD3/e1V7546fU6+9/L646e5s+GxeNpYQVmddb1F/GPfUatG+gr7hwK2w7LWv/dQaIfy0vzyVyQrknG0WhSBnv1uPMraBVKZh6QK1CNkz0DtIcljSZelLc7mnS1dINcpS0BcN8CayqTL0Ea2o8nHmA6q0TUy3VBphadlUamBqArUKU49Mz+q0Vqcxph1jZlAamW4ELiRbD9MIlG/sgkydAdETkMt1mQ4AyrMzZ1gX/1hGCw290xjNqzusoyvmTNCMJUPtfmQdDp0p/1HLVKKdo/4UN+h/sIZouqLSXuBqxqsDV5Dkyn9CfdIlJ8/PIQT56jTuMsYVZ9BPIDj9bi87+azum5OxgVuFJHHJenpsxrfd1gY2kA6aVlNmuZFI3zLjIAuqVPzxPgAdmUR8Y8jwkQAAAABJRU5ErkJggg=="

/***/ }),
/* 52 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/beian.d0289dc.png";

/***/ }),
/* 53 */
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,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"

/***/ }),
/* 54 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/cz1.1f4b952.png";

/***/ }),
/* 55 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/czheader2.a4ab86e.png";

/***/ }),
/* 56 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/czqrcode.3c213e3.png";

/***/ }),
/* 57 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/cztqrcode.82d43c6.png";

/***/ }),
/* 58 */
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,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"

/***/ }),
/* 59 */
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAADIAAAAyCAMAAAAp4XiDAAAAllBMVEUAAAD////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////AJcWoAAAAMXRSTlMALcS3Swv1hnlP5tzPDQj6sWwVrUQF136ngygSolXs4ZJ7aO1zVyYa7sa/XzcR75Yg5nZNVwAAAg1JREFUSMel1tuSojAQBuBGkDMCg6gDnmad0Tnu7v/+L7d0akODRCmL78pQldhJJ53Q0NzxstUpTU+rzHPmNGqex+iJ8/u9rBkMZhbd8rQGc20/qOqyrKvAt12w9RMZBSEa9m5BHYudjUYYkMEzGoVliLZA49k8i2hJRstIzcjQY5PQDclm2Id7vNAdL9zneh453fULgCfNAIBPI3wAQZuPENjQqA0Q6vysgSihUUkErEmxACyJxi0BWHq1CtK8KO4n+nsWHfXv4v+qzVVfWTppqXmisSWJh/d1DtikqV34SeIPmG7ZULmIgTfSDmBn2ZVgrm6+AbGKy130EgZkMjWwYzuCy5E5bVwSGS69P0FCncgc8vqJf0V3vn7bkg8eZdxPlKkeV/6zcyQdjnoFVIOThmNnZgWJCljRHqh7JQaKWpHfYH9J1MCeUqCkriP0uf0Cs6mjBNJhl7pNRQhmDbrowMQW7JUCsI/r8fbt9MUF7EAfYN9EV9OXRRYZmK2WO9YfZZElleIMIcNJKmXDiE9oB/koG0a2pbCgyXGTbSmbX6hvSkh9OyDWR2x4ypWvYVy5HOS+COxkCDiRcjFYTJVOIeViWJTkRLumonS79F3scGaZSt/jBfbxMv74ZTHpShq/+Lbq4pt2vSre/Uvcm/JUMD9InOqnLH/OjjxIJj17pj+u5An3nqbvN55w/wCPmHT86sAbdwAAAABJRU5ErkJggg=="

/***/ }),
/* 60 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/mqrcodes.03194ce.png";

/***/ }),
/* 61 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/phone.4621c96.png";

/***/ }),
/* 62 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/qrcode.0d3fa5e.png";

/***/ }),
/* 63 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/teacher-header.5587eb1.png";

/***/ }),
/* 64 */
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAGAAAAAxCAMAAAFlk2zOAAAAGXRFWHRTb2Z0d2FyZQBBZG9iZSBJbWFnZVJlYWR5ccllPAAAAwBQTFRF/Pz8m5ubr6+vmJiYra2t/f39ysrK1dXVoKCgw8PDy8vL+fn57+/vz8/P8vLy6+vr9fX1vb29tLS0kpKSqKio+/v7+vr6o6OjhoaGoqKii4uLn5+foaGhnJyctbW1iYmJsLCwiIiItra2np6ehYWF////////JycnKCgoKSkpKioqKysrLCwsLS0tLi4uLy8vMDAwMTExMjIyMzMzNDQ0NTU1NjY2Nzc3ODg4OTk5Ojo6Ozs7PDw8PT09Pj4+Pz8/QEBAQUFBQkJCQ0NDRERERUVFRkZGR0dHSEhISUlJSkpKS0tLTExMTU1NTk5OT09PUFBQUVFRUlJSU1NTVFRUVVVVVlZWV1dXWFhYWVlZWlpaW1tbXFxcXV1dXl5eX19fYGBgYWFhYmJiY2NjZGRkZWVlZmZmZ2dnaGhoaWlpampqa2trbGxsbW1tbm5ub29vcHBwcXFxcnJyc3NzdHR0dXV1dnZ2d3d3eHh4eXl5enp6e3t7fHx8fX19fn5+f39/gICAgYGBgoKCg4ODhISEhYWFhoaGh4eHiIiIiYmJioqKi4uLjIyMjY2Njo6Oj4+PkJCQkZGRkpKSk5OTlJSUlZWVlpaWl5eXmJiYmZmZmpqam5ubnJycnZ2dnp6en5+foKCgoaGhoqKio6OjpKSkpaWlpqamp6enqKioqampqqqqq6urrKysra2trq6ur6+vsLCwsbGxsrKys7OztLS0tbW1tra2t7e3uLi4ubm5urq6u7u7vLy8vb29vr6+v7+/wMDAwcHBwsLCw8PDxMTExcXFxsbGx8fHyMjIycnJysrKy8vLzMzMzc3Nzs7Oz8/P0NDQ0dHR0tLS09PT1NTU1dXV1tbW19fX2NjY2dnZ2tra29vb3Nzc3d3d3t7e39/f4ODg4eHh4uLi4+Pj5OTk5eXl5ubm5+fn6Ojo6enp6urq6+vr7Ozs7e3t7u7u7+/v8PDw8fHx8vLy8/Pz9PT09fX19vb29/f3+Pj4+fn5+vr6+/v7/Pz8/f39/v7+////mNFkCwAAACd0Uk5T//////////////////////////////////////////////////8Ag1aX2QAAAiRJREFUeNpiUJsHAmqtIMAAZs9rhXP+gzn/wZz///8DOUASQwZJD7JpAAHEsBbEPj0DxN6LYTQy5z/YtP//MTlIyraB2FcXg9inAAKIYf08BJjdigAMSOLzWjEkQH6ASYB8Qp7EFiQ7FiDZARBADH8Q4mq/EeJqBFxFugTEUTBXIST+Izn3P5I//v+HykDFwTL4jSJDgiR//EUKqz9IYQUQQAy/5mEFK362YgWTGObhAK04AFTDf2SApAFFHNMT/3HY8B+7rxGmo2pAmI6iAdVBCA2oDqLMDyQ6iR4aiIy4v9jVr/+DXf1sgABiUDuNRfnaP2pqe7Eon/FbjWEFdht+TcJuw09cftiAwwtzyE2tFCXveTiSBmU2YGSHeTiyA1rSwKoBOWEga0BNSvNwJCWMDIShATX7IDSgZ7h5ODIclmCdhyNY0WscrPHwH188kOrpkamBxhkIA2zBoX4BSmsECfydjV3DHwa1q1iUb/2rpnYKi/JFf9QAArRbxigMAkEUndPMTVcSvIAgTAzW4iHsbKw8hYUgWMfaZGd2fqOI+Qf4b/f/D7vEcyNuNTPzVAS3iolpEEhDFyB19MIA7wwDPElABVDHAj6atO+HptNusL8LAvg6dgoQScYERJKxAEr4KkAJXwMY/UYBRr8xQGJCP4DEhLwzFXCmqZKtCiRYJThX9AfcAHCx96DC/OsH5p/TiAHGHgP0xGvrt29X5qX025cLbyiipPdIdX1gAAAAAElFTkSuQmCC"

/***/ }),
/* 65 */
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABQAAAASCAMAAABsDg4iAAAAilBMVEUAAAD////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////2N2iNAAAALXRSTlMA4fW9sn0G+dWcSxgT2sGYiYUtDu3m3M20qpKAbWZeV1UzA+/ez8i4o3hCPCTxXHxqAAAAuElEQVQY01WPVRLDMAwF5TgMDTOnDLr/9SpNEjfdjzfyjkcAzBzJQth154HiI3FDi8zNJRn+KFNgzAJRuicSzZQj1sCM9BxhoPThQZmwdKiwnwFl1WqUBssKFVZQCitkGe5Kbxx5vekGL+CuKosErog32RMysYWC9UWgNgN4NtX3gKb7VKQeNeJN6W/Icw2Olg4DQuROhwdY+nEKy/kgJWzEB/napamrE3pQLIO9Sgf+8NzJTXpa6AudlyI7KNSMogAAAABJRU5ErkJggg=="

/***/ }),
/* 66 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(27),
  /* template */
  __webpack_require__(79),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 67 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(28),
  /* template */
  __webpack_require__(91),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 68 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(43)
}
var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(29),
  /* template */
  __webpack_require__(92),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-98fe5322",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 69 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(42)
}
var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(30),
  /* template */
  __webpack_require__(90),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-8405cd50",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 70 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(31),
  /* template */
  __webpack_require__(86),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 71 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(32),
  /* template */
  __webpack_require__(83),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 72 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(39)
}
var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(33),
  /* template */
  __webpack_require__(82),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-228d8f57",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 73 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(34),
  /* template */
  __webpack_require__(81),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 74 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(44)
}
var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(35),
  /* template */
  __webpack_require__(93),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-c9d40452",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 75 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(38)
}
var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(36),
  /* template */
  __webpack_require__(80),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-0734a327",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 76 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(41)
}
var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(37),
  /* template */
  __webpack_require__(89),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-6721b45e",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 77 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(22),
  /* template */
  __webpack_require__(84),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 78 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(23),
  /* template */
  __webpack_require__(88),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 79 */
/***/ (function(module, exports, __webpack_require__) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('my-menu', {
    attrs: {
      "menu-name": "about"
    }
  }), _vm._v(" "), _vm._m(0), _vm._v(" "), _c('div', {
    staticClass: "about_content"
  }, [_vm._m(1), _vm._v(" "), _c('div', {
    staticClass: "join"
  }, [_c('ul', {
    staticClass: "join_menu"
  }, [_c('li', {
    class: {
      active: _vm.all
    }
  }, [_c('a', {
    attrs: {
      "href": "javascript:;"
    },
    on: {
      "click": function($event) {
        return _vm.clickHandler($event, 'all')
      }
    }
  }, [_vm._v("全部")])]), _vm._v(" "), _c('li', {
    class: {
      active: _vm.product
    }
  }, [_c('a', {
    attrs: {
      "href": "javascript:;"
    },
    on: {
      "click": function($event) {
        return _vm.clickHandler($event, 'product')
      }
    }
  }, [_vm._v("产品")])]), _vm._v(" "), _c('li', {
    class: {
      active: _vm.technology
    }
  }, [_c('a', {
    attrs: {
      "href": "javascript:;"
    },
    on: {
      "click": function($event) {
        return _vm.clickHandler($event, 'technology')
      }
    }
  }, [_vm._v("技术")])]), _vm._v(" "), _c('li', {
    class: {
      active: _vm.design
    }
  }, [_c('a', {
    attrs: {
      "href": "javascript:;"
    },
    on: {
      "click": function($event) {
        return _vm.clickHandler($event, 'design')
      }
    }
  }, [_vm._v("设计")])]), _vm._v(" "), _c('li', {
    class: {
      active: _vm.operation
    }
  }, [_c('a', {
    attrs: {
      "href": "javascript:;"
    },
    on: {
      "click": function($event) {
        return _vm.clickHandler($event, 'operation')
      }
    }
  }, [_vm._v("运营")])])]), _vm._v(" "), _c('div', {
    staticClass: "job_list"
  }, _vm._l((_vm.positions), function(item, index) {
    return _c('div', {
      key: index,
      staticClass: "job_item"
    }, [_c('div', {
      staticClass: "job_position"
    }, [_c('div', {
      staticClass: "job_title"
    }, [_vm._v(_vm._s(item.name))]), _vm._v(" "), _c('div', {
      staticClass: "job_require"
    }, [_c('div', {
      staticClass: "job_require_title"
    }, [_vm._v("职位要求")]), _vm._v(" "), _c('div', {
      staticClass: "job_require_content"
    }, [_c('div', {
      domProps: {
        "innerHTML": _vm._s(item.require)
      }
    })])])]), _vm._v(" "), _c('div', {
      staticClass: "job_content"
    }, [_c('div', {
      staticClass: "job_content_title"
    }, [_vm._v("工作内容")]), _vm._v(" "), _c('div', {
      staticClass: "job_content_text"
    }, [_c('div', {
      domProps: {
        "innerHTML": _vm._s(item.content)
      }
    })])])])
  }), 0), _vm._v(" "), _c('div', {
    staticClass: "clear"
  })])]), _vm._v(" "), _c('my-footer')], 1)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "banner"
  }, [_c('img', {
    staticClass: "bg",
    attrs: {
      "src": __webpack_require__(48)
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "about_header_content"
  }, [_c('div', {
    staticClass: "about_desc"
  }, [_c('div', {
    staticClass: "about_logo"
  }, [_c('img', {
    attrs: {
      "src": __webpack_require__(49)
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "about_text"
  }, [_c('div', {
    staticClass: "v_line"
  }), _vm._v(" "), _c('p', {
    staticClass: "p_title"
  }, [_vm._v("维学教育科技")]), _vm._v(" "), _c('p', [_vm._v("北京维学教育科技有限公司是一家专注K12英语教育的移动互联网创业公司，\n          公司利用多年的英语教育经验，提供全方位的学习解决方案，并将成熟的智能教育技术与产品，\n          运用到学校更多的教与学场景，致力打造专注，知名的网络教育品牌。")])])])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "about"
  }, [_c('p', [_vm._v("Enjoy Studying")]), _vm._v(" "), _c('div', {
    staticClass: "v_line",
    staticStyle: {
      "background-color": "#7c7c7c"
    }
  }), _vm._v(" "), _c('p', [_vm._v("加入我们")])])
}]}

/***/ }),
/* 80 */
/***/ (function(module, exports, __webpack_require__) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('my-menu', {
    attrs: {
      "menu-name": "home"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "banner"
  }, [_c('img', {
    staticClass: "bg",
    attrs: {
      "src": __webpack_require__(63)
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "wrapper"
  }, [_c('div', {
    staticClass: "switch"
  }, [_c('router-link', {
    attrs: {
      "to": "/"
    }
  }, [_vm._v("教师端")]), _vm._v(" "), _c('router-link', {
    staticClass: "switch-active",
    attrs: {
      "to": "/student"
    }
  }, [_vm._v("学生端")])], 1), _vm._v(" "), _vm._m(0), _vm._v(" "), _vm._m(1)])]), _vm._v(" "), _c('section', {
    staticClass: "content"
  }, [_vm._m(2), _vm._v(" "), _vm._m(3), _vm._v(" "), _c('div', {
    staticClass: "card"
  }, [_c('ul', [_c('li', [_vm._m(4), _vm._v(" "), _c('div', {
    staticClass: "img_right"
  }, [_c('img', {
    directives: [{
      name: "lazy",
      rawName: "v-lazy",
      value: ('/static/images/home/5.png'),
      expression: "'/static/images/home/5.png'"
    }]
  })])]), _vm._v(" "), _c('li', [_c('div', {
    staticClass: "img_left"
  }, [_c('img', {
    directives: [{
      name: "lazy",
      rawName: "v-lazy",
      value: ('/static/images/home/6.png'),
      expression: "'/static/images/home/6.png'"
    }]
  })]), _vm._v(" "), _vm._m(5)]), _vm._v(" "), _c('li', [_vm._m(6), _vm._v(" "), _c('div', {
    staticClass: "img_right"
  }, [_c('img', {
    directives: [{
      name: "lazy",
      rawName: "v-lazy",
      value: ('/static/images/home/7.png'),
      expression: "'/static/images/home/7.png'"
    }]
  })])])])])]), _vm._v(" "), _c('my-footer')], 1)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "inner"
  }, [_c('p', {
    staticClass: "text_weici"
  }, [_vm._v("维词教师版")]), _vm._v(" "), _c('p', {
    staticClass: "text_slogan"
  }, [_vm._v("让你的英语教学更精彩")]), _vm._v(" "), _c('div', {
    staticClass: "product_list"
  }, [_c('a', {
    staticClass: "product_item",
    attrs: {
      "href": "https://bsource.weicistudy.com/pc_download/weici_setup_win.exe",
      "target": "_blank"
    }
  }, [_c('img', {
    attrs: {
      "src": __webpack_require__(10)
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "product_des"
  }, [_c('p', [_vm._v("点击下载")]), _vm._v(" "), _c('p', [_vm._v("高中维词教学系统")]), _vm._v(" "), _c('p', [_vm._v("（PC客户端）")])])]), _vm._v(" "), _c('a', {
    staticClass: "product_item",
    attrs: {
      "href": "https://bsource.weicistudy.com/pc_download/weici_setup_mac.dmg",
      "target": "_blank"
    }
  }, [_c('img', {
    attrs: {
      "src": __webpack_require__(15)
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "product_des"
  }, [_c('p', [_vm._v("点击下载")]), _vm._v(" "), _c('p', [_vm._v("高中维词教学系统")]), _vm._v(" "), _c('p', [_vm._v("（MAC客户端）")])])]), _vm._v(" "), _c('div', {
    staticClass: "product_item"
  }, [_c('img', {
    attrs: {
      "src": __webpack_require__(60)
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "product_des"
  }, [_c('p', [_vm._v("扫码下载")]), _vm._v(" "), _c('p', [_vm._v("高中维词教师版")]), _vm._v(" "), _c('p', [_vm._v("APP移动端")])])])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "download"
  }, [_c('a', {
    attrs: {
      "href": "https://itunes.apple.com/cn/app/%E7%BB%B4%E8%AF%8D%E6%95%99%E5%B8%88%E7%89%88/id1354318280?mt=8",
      "target": "_blank"
    }
  }, [_c('img', {
    attrs: {
      "src": __webpack_require__(9)
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "line"
  }), _vm._v(" "), _c('a', {
    attrs: {
      "href": "http://a.app.qq.com/o/simple.jsp?pkgname=com.android.weici.senior.teacher",
      "target": "_blank"
    }
  }, [_c('img', {
    attrs: {
      "src": __webpack_require__(7)
    }
  })])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "text"
  }, [_c('p', [_vm._v("维词教师版是一款")]), _vm._v(" "), _c('p', [_vm._v("为高中英语老师精心准备的教学辅助工具")]), _vm._v(" "), _c('p', [_vm._v("内容融入英语教学各个场景  为学生英语学习提供帮助")]), _vm._v(" "), _c('p', [_vm._v("WEICI App (Teacher's Edition) ")]), _vm._v(" "), _c('p', [_vm._v("is specially designed as an effective tool")]), _vm._v(" "), _c('p', [_vm._v("for High School English teachers to help their students improve scores.")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "arrow"
  }, [_c('img', {
    attrs: {
      "src": __webpack_require__(3)
    }
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "card_text"
  }, [_c('p', {
    staticClass: "title"
  }, [_vm._v("精选优质内容")]), _vm._v(" "), _c('p', {
    staticClass: "title"
  }, [_vm._v("给老师赋能")]), _vm._v(" "), _c('p', [_vm._v("大数据标注历年考点，多维度精讲词汇")]), _vm._v(" "), _c('p', [_vm._v("专业教学设计，精准同步教材")]), _vm._v(" "), _c('p', [_vm._v("优质课件、影音词汇讲解，备课资源丰富 ")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "card_text right"
  }, [_c('p', {
    staticClass: "title"
  }, [_vm._v("智能分析")]), _vm._v(" "), _c('p', {
    staticClass: "title"
  }, [_vm._v("帮学生查漏补缺")]), _vm._v(" "), _c('p', [_vm._v("精选题库、多种题型，一键布置作业")]), _vm._v(" "), _c('p', [_vm._v("大数据智能分析，检查作业更轻松")]), _vm._v(" "), _c('p', [_vm._v("分层教学，真正实现因材施教")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "card_text"
  }, [_c('p', {
    staticClass: "title"
  }, [_vm._v("融入教学场景")]), _vm._v(" "), _c('p', {
    staticClass: "title"
  }, [_vm._v("为老师赋能")]), _vm._v(" "), _c('p', [_vm._v("课前预习，讲课更轻松")]), _vm._v(" "), _c('p', [_vm._v("课上多种教学方式，激发学生英语学习兴趣")]), _vm._v(" "), _c('p', [_vm._v("课后巩固、查漏补缺，培养学生好习惯")])])
}]}

/***/ }),
/* 81 */
/***/ (function(module, exports, __webpack_require__) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('my-menu', {
    attrs: {
      "menu-name": "junior"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "banner"
  }, [_c('img', {
    staticClass: "bg",
    attrs: {
      "src": __webpack_require__(55)
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "wrapper"
  }, [_c('div', {
    staticClass: "switch"
  }, [_c('router-link', {
    staticClass: "switch-active",
    attrs: {
      "to": "/teachercz"
    }
  }, [_vm._v("教师端")]), _vm._v(" "), _c('router-link', {
    attrs: {
      "to": "/junior"
    }
  }, [_vm._v("学生端")])], 1), _vm._v(" "), _vm._m(0), _vm._v(" "), _vm._m(1)])]), _vm._v(" "), _c('section', {
    staticClass: "content"
  }, [_vm._m(2), _vm._v(" "), _vm._m(3), _vm._v(" "), _c('div', {
    staticClass: "junior_card"
  }, [_c('ul', [_c('li', [_c('img', {
    directives: [{
      name: "lazy",
      rawName: "v-lazy",
      value: ('/static/images/cz1.png'),
      expression: "'/static/images/cz1.png'"
    }]
  }), _vm._v(" "), _vm._m(4)]), _vm._v(" "), _c('li', [_c('img', {
    directives: [{
      name: "lazy",
      rawName: "v-lazy",
      value: ('/static/images/cz2.png'),
      expression: "'/static/images/cz2.png'"
    }]
  }), _vm._v(" "), _vm._m(5)]), _vm._v(" "), _c('li', [_c('img', {
    directives: [{
      name: "lazy",
      rawName: "v-lazy",
      value: ('/static/images/cz3.png'),
      expression: "'/static/images/cz3.png'"
    }]
  }), _vm._v(" "), _vm._m(6)]), _vm._v(" "), _c('li', [_c('img', {
    directives: [{
      name: "lazy",
      rawName: "v-lazy",
      value: ('/static/images/cz4.png'),
      expression: "'/static/images/cz4.png'"
    }]
  }), _vm._v(" "), _vm._m(7)])])])]), _vm._v(" "), _c('my-footer')], 1)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "inner"
  }, [_c('p', {
    staticClass: "text_weici"
  }, [_vm._v("维词•初中生")]), _vm._v(" "), _c('p', {
    staticClass: "text_slogan"
  }, [_vm._v("自主学习词汇APP")]), _vm._v(" "), _c('img', {
    staticClass: "qrcode",
    attrs: {
      "src": __webpack_require__(56)
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "text_download"
  }, [_vm._v("扫描下载APP")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "download"
  }, [_c('a', {
    attrs: {
      "href": "https://itunes.apple.com/cn/app/%E7%BB%B4%E8%AF%8D%E5%88%9D%E4%B8%AD%E7%89%88/id1228082964?mt=8",
      "target": "_blank"
    }
  }, [_c('img', {
    attrs: {
      "src": __webpack_require__(9)
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "line"
  }), _vm._v(" "), _c('a', {
    attrs: {
      "href": "http://android.myapp.com/myapp/detail.htm?apkName=com.victorstudy.weici.junior",
      "target": "_blank"
    }
  }, [_c('img', {
    attrs: {
      "src": __webpack_require__(7)
    }
  })])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "text"
  }, [_c('p', [_vm._v("维词APP初中版")]), _vm._v(" "), _c('p', [_vm._v("通过语音、词块，中英文差异句的输入")]), _vm._v(" "), _c('p', [_vm._v("有效培养英语学习能力，成为初中词汇学习APP")]), _vm._v(" "), _c('p')])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "arrow"
  }, [_c('img', {
    attrs: {
      "src": __webpack_require__(3)
    }
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "junior_label"
  }, [_c('p', [_vm._v("词汇精讲")]), _vm._v(" "), _c('p', [_vm._v("标注适合背诵例句、培养词块学习意识")]), _vm._v(" "), _c('p', [_vm._v("点拨学生易犯错误、突出英汉表达差异")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "junior_label"
  }, [_c('p', [_vm._v("同步教材")]), _vm._v(" "), _c('p', [_vm._v("教材单元同步学习")]), _vm._v(" "), _c('p', [_vm._v("备考分级学习，同步课堂学习计划")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "junior_label"
  }, [_c('p', [_vm._v("紧扣教学")]), _vm._v(" "), _c('p', [_vm._v("标注单词词频、精选例句、自由订制学习计划")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "junior_label"
  }, [_c('p', [_vm._v("真人离线发声")]), _vm._v(" "), _c('p', [_vm._v("真人离线无延迟、精选词块、例句朗读、跟读")])])
}]}

/***/ }),
/* 82 */
/***/ (function(module, exports, __webpack_require__) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('my-menu', {
    attrs: {
      "menu-name": "home"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "banner"
  }, [_c('img', {
    staticClass: "bg",
    attrs: {
      "src": __webpack_require__(8)
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "wrapper"
  }, [_c('div', {
    staticClass: "switch"
  }, [_c('router-link', {
    staticClass: "switch-active",
    attrs: {
      "to": "/"
    }
  }, [_vm._v("教师端")]), _vm._v(" "), _c('router-link', {
    attrs: {
      "to": "/student"
    }
  }, [_vm._v("学生端")])], 1), _vm._v(" "), _vm._m(0)])]), _vm._v(" "), _c('section', {
    staticClass: "content"
  }, [_vm._m(1), _vm._v(" "), _vm._m(2), _vm._v(" "), _c('div', {
    staticClass: "card"
  }, [_c('ul', [_c('li', [_vm._m(3), _vm._v(" "), _c('div', {
    staticClass: "img_right"
  }, [_c('img', {
    directives: [{
      name: "lazy",
      rawName: "v-lazy",
      value: ('/static/images/home/1.png'),
      expression: "'/static/images/home/1.png'"
    }]
  })])]), _vm._v(" "), _c('li', [_c('div', {
    staticClass: "img_left"
  }, [_c('img', {
    directives: [{
      name: "lazy",
      rawName: "v-lazy",
      value: ('/static/images/home/2.png'),
      expression: "'/static/images/home/2.png'"
    }]
  })]), _vm._v(" "), _vm._m(4)]), _vm._v(" "), _c('li', [_vm._m(5), _vm._v(" "), _c('div', {
    staticClass: "img_right"
  }, [_c('img', {
    directives: [{
      name: "lazy",
      rawName: "v-lazy",
      value: ('/static/images/home/3.png'),
      expression: "'/static/images/home/3.png'"
    }]
  })])]), _vm._v(" "), _c('li', [_c('div', {
    staticClass: "img_left"
  }, [_c('img', {
    directives: [{
      name: "lazy",
      rawName: "v-lazy",
      value: ('/static/images/home/4.png'),
      expression: "'/static/images/home/4.png'"
    }]
  })]), _vm._v(" "), _vm._m(6)])])])]), _vm._v(" "), _c('my-footer')], 1)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "product_list"
  }, [_c('div', {
    staticClass: "product_item"
  }, [_c('img', {
    staticStyle: {
      "width": "176px",
      "display": "inline-block"
    },
    attrs: {
      "src": __webpack_require__(58)
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "product_des"
  }, [_c('p', [_vm._v("扫码下载")]), _vm._v(" "), _c('p', [_vm._v("维词学生版APP")])])]), _vm._v(" "), _c('a', {
    staticClass: "product_item",
    attrs: {
      "href": "https://bsource.weicistudy.com/pc_download/aistudent/weici-student.exe",
      "target": "_blank"
    }
  }, [_c('img', {
    attrs: {
      "src": __webpack_require__(10)
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "product_des"
  }, [_c('p', [_vm._v("点击下载")]), _vm._v(" "), _c('p', [_vm._v("维词数智化学生端")])])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "text"
  }, [_c('p', [_vm._v("维词app是一款专为高中生")]), _vm._v(" "), _c('p', [_vm._v("打造的英语学习软件")]), _vm._v(" "), _c('p', [_vm._v("让用户可以轻松的掌握高中英语知识")]), _vm._v(" "), _c('p', [_vm._v("Victor English Vocabulary APP is specially designed for high school students, ")]), _vm._v(" "), _c('p', [_vm._v("\n            to satisfy the needs for English studies and to master high school English knowledge and skills\n        ")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "arrow"
  }, [_c('img', {
    attrs: {
      "src": __webpack_require__(3)
    }
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "card_text"
  }, [_c('p', {
    staticClass: "title"
  }, [_vm._v("学习资源丰富")]), _vm._v(" "), _c('p', {
    staticClass: "title"
  }, [_vm._v("内容精准")]), _vm._v(" "), _c('p', [_vm._v("5676个精讲词条，15979个例句音频")]), _vm._v(" "), _c('p', [_vm._v("大数据精选知识点，分层深度学习")]), _vm._v(" "), _c('p', [_vm._v("精彩发现区，让单词学习有趣、有效")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "card_text right"
  }, [_c('p', {
    staticClass: "title"
  }, [_vm._v("同步课堂教学")]), _vm._v(" "), _c('p', {
    staticClass: "title"
  }, [_vm._v("融入学习各个场景")]), _vm._v(" "), _c('p', [_vm._v("同步教学进度、教材预习，课堂更轻松")]), _vm._v(" "), _c('p', [_vm._v("精选练习、作业、老师推荐，学习有的放矢")]), _vm._v(" "), _c('p', [_vm._v("词汇分级、话题学习，备考轻松")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "card_text"
  }, [_c('p', {
    staticClass: "title"
  }, [_vm._v("练测题型多样")]), _vm._v(" "), _c('p', {
    staticClass: "title"
  }, [_vm._v("考察全面")]), _vm._v(" "), _c('p', [_vm._v("七大题型，覆盖单词学习核心要点")]), _vm._v(" "), _c('p', [_vm._v("错题自动收录，随时随地巩固")]), _vm._v(" "), _c('p', [_vm._v("告别枯燥刷题，学习过程更有趣")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "card_text right"
  }, [_c('p', {
    staticClass: "title"
  }, [_vm._v("智能语音互动")]), _vm._v(" "), _c('p', {
    staticClass: "title"
  }, [_vm._v("听说能力提升快")]), _vm._v(" "), _c('p', [_vm._v("真人离线发音，提供精准语音输入")]), _vm._v(" "), _c('p', [_vm._v("单词例句跟读，告别“哑巴”英语")]), _vm._v(" "), _c('p', [_vm._v("错误发音即时纠正，英语学习更自信")])])
}]}

/***/ }),
/* 83 */
/***/ (function(module, exports, __webpack_require__) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "d_container"
  }, [_c('my-menu', {
    attrs: {
      "menu-name": "home"
    }
  }), _vm._v(" "), _vm._m(0), _vm._v(" "), _vm._m(1), _vm._v(" "), _c('img', {
    staticClass: "phone",
    attrs: {
      "src": __webpack_require__(61)
    }
  })], 1)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "download_box box1"
  }, [_c('div', {
    staticClass: "down_left"
  }, [_c('img', {
    attrs: {
      "src": __webpack_require__(51)
    }
  }), _vm._v(" "), _c('span', {
    staticStyle: {
      "font-size": "24px",
      "font-weight": "bold",
      "color": "#333333",
      "display": "block"
    }
  }, [_vm._v("苹果版")])]), _vm._v(" "), _c('div', {
    staticClass: "down_right"
  }, [_c('ul', [_c('li', [_c('a', {
    attrs: {
      "href": "https://itunes.apple.com/us/app/apple-store/id1171638702",
      "target": "_blank"
    }
  }, [_vm._v("人教版")])]), _vm._v(" "), _c('li', [_c('a', {
    attrs: {
      "href": "https://itunes.apple.com/us/app/apple-store/id1179268416",
      "target": "_blank"
    }
  }, [_vm._v("译林版")])]), _vm._v(" "), _c('li', [_c('a', {
    attrs: {
      "href": "https://itunes.apple.com/us/app/apple-store/id1179239368",
      "target": "_blank"
    }
  }, [_vm._v("北师大版")])]), _vm._v(" "), _c('li', [_c('a', {
    attrs: {
      "href": "https://itunes.apple.com/us/app/apple-store/id1179267262",
      "target": "_blank"
    }
  }, [_vm._v("外研版")])])])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "download_box box2"
  }, [_c('div', {
    staticClass: "down_left"
  }, [_c('img', {
    attrs: {
      "src": __webpack_require__(50)
    }
  }), _vm._v(" "), _c('span', {
    staticStyle: {
      "font-size": "24px",
      "font-weight": "bold",
      "color": "#333333",
      "display": "block"
    }
  }, [_vm._v("安卓版")])]), _vm._v(" "), _c('div', {
    staticClass: "down_right"
  }, [_c('ul', [_c('li', [_c('a', {
    attrs: {
      "href": "http://zhushou.360.cn/detail/index/soft_id/3585073",
      "target": "_blank"
    }
  }, [_vm._v("人教版")])]), _vm._v(" "), _c('li', [_c('a', {
    attrs: {
      "href": "http://zhushou.360.cn/detail/index/soft_id/3589976",
      "target": "_blank"
    }
  }, [_vm._v("译林版")])]), _vm._v(" "), _c('li', [_c('a', {
    attrs: {
      "href": "http://zhushou.360.cn/detail/index/soft_id/3589970",
      "target": "_blank"
    }
  }, [_vm._v("北师大版")])]), _vm._v(" "), _c('li', [_c('a', {
    attrs: {
      "href": "http://zhushou.360.cn/detail/index/soft_id/3589974",
      "target": "_blank"
    }
  }, [_vm._v("外研版")])])])])])
}]}

/***/ }),
/* 84 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    class: _vm.slideClass
  }, [_vm._t("default")], 2)
},staticRenderFns: []}

/***/ }),
/* 85 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    attrs: {
      "id": "app"
    }
  }, [_c('router-view')], 1)
},staticRenderFns: []}

/***/ }),
/* 86 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('my-menu', {
    attrs: {
      "menu-name": "discovery"
    }
  }), _vm._v(" "), _c('my-footer')], 1)
},staticRenderFns: []}

/***/ }),
/* 87 */
/***/ (function(module, exports, __webpack_require__) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "footer"
  }, [_c('img', {
    attrs: {
      "src": __webpack_require__(53)
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "footer_right"
  }, [_c('div', {
    staticClass: "compony"
  }, [_vm._v("北京维学教育科技有限公司")]), _vm._v(" "), _c('div', {
    staticClass: "link"
  }, [_c('span', [_vm._v("weici@weixuetec.com")]), _vm._v("\n      Ι\n      "), _c('span', [_vm._v("京ICP备16053030号")]), _vm._v("\n      Ι\n      "), _c('a', {
    staticClass: "wechat",
    attrs: {
      "href": "javascript:;"
    }
  }, [_c('img', {
    attrs: {
      "src": __webpack_require__(65)
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "show_qrcode"
  })]), _vm._v("\n\n      Ι\n      "), _c('span', [_vm._v("电话：010-82809918-8020")])]), _vm._v(" "), _c('div', {
    staticStyle: {
      "font-size": "15px",
      "margin-top": "6px"
    }
  }, [_vm._v("地址：北京朝阳区北苑路北辰新纪元大厦2号楼 804")])]), _vm._v(" "), _c('div', {
    staticStyle: {
      "width": "300px",
      "margin": "0 auto",
      "padding": "20px 0 0 0"
    }
  }, [_c('a', {
    staticStyle: {
      "display": "inline-block",
      "text-decoration": "none",
      "height": "20px",
      "line-height": "20px"
    },
    attrs: {
      "target": "_blank",
      "href": "http://www.beian.gov.cn/portal/registerSystemInfo?recordcode=11010502033934"
    }
  }, [_c('img', {
    staticStyle: {
      "float": "left",
      "width": "20px"
    },
    attrs: {
      "src": __webpack_require__(52)
    }
  }), _vm._v(" "), _c('p', {
    staticStyle: {
      "float": "left",
      "height": "20px",
      "line-height": "20px",
      "margin": "0px 0px 0px 5px",
      "color": "#939393",
      "font-size": "14px"
    }
  }, [_vm._v("\n        京公网安备 11010502033934号\n      ")])])])])
}]}

/***/ }),
/* 88 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "swiper-container"
  }, [_vm._t("parallax-bg"), _vm._v(" "), _c('div', {
    class: _vm.defaultSwiperClasses.wrapperClass
  }, [_vm._t("default")], 2), _vm._v(" "), _vm._t("pagination"), _vm._v(" "), _vm._t("button-prev"), _vm._v(" "), _vm._t("button-next"), _vm._v(" "), _vm._t("scrollbar")], 2)
},staticRenderFns: []}

/***/ }),
/* 89 */
/***/ (function(module, exports, __webpack_require__) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('my-menu', {
    attrs: {
      "menu-name": "junior"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "banner"
  }, [_c('img', {
    staticClass: "bg",
    attrs: {
      "src": __webpack_require__(14)
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "wrapper"
  }, [_c('div', {
    staticClass: "switch"
  }, [_c('router-link', {
    attrs: {
      "to": "/teachercz"
    }
  }, [_vm._v("教师端")]), _vm._v(" "), _c('router-link', {
    staticClass: "switch-active",
    attrs: {
      "to": "/junior"
    }
  }, [_vm._v("学生端")])], 1), _vm._v(" "), _vm._m(0), _vm._v(" "), _vm._m(1)])]), _vm._v(" "), _c('section', {
    staticClass: "content"
  }, [_vm._m(2), _vm._v(" "), _vm._m(3), _vm._v(" "), _c('div', {
    staticClass: "card"
  }, [_c('ul', [_c('li', [_vm._m(4), _vm._v(" "), _c('div', {
    staticClass: "img_right"
  }, [_c('img', {
    directives: [{
      name: "lazy",
      rawName: "v-lazy",
      value: ('/static/images/home/5.png'),
      expression: "'/static/images/home/5.png'"
    }]
  })])]), _vm._v(" "), _c('li', [_c('div', {
    staticClass: "img_left"
  }, [_c('img', {
    directives: [{
      name: "lazy",
      rawName: "v-lazy",
      value: ('/static/images/home/6.png'),
      expression: "'/static/images/home/6.png'"
    }]
  })]), _vm._v(" "), _vm._m(5)]), _vm._v(" "), _c('li', [_vm._m(6), _vm._v(" "), _c('div', {
    staticClass: "img_right"
  }, [_c('img', {
    directives: [{
      name: "lazy",
      rawName: "v-lazy",
      value: ('/static/images/home/7.png'),
      expression: "'/static/images/home/7.png'"
    }]
  })])])])])]), _vm._v(" "), _c('my-footer')], 1)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "inner"
  }, [_c('p', {
    staticClass: "text_weici"
  }, [_vm._v("维词教师版")]), _vm._v(" "), _c('p', {
    staticClass: "text_slogan"
  }, [_vm._v("让你的英语教学更精彩")]), _vm._v(" "), _c('div', {
    staticClass: "product_list"
  }, [_c('a', {
    staticClass: "product_item",
    attrs: {
      "href": "https://bsource.weicistudy.com/pc_download/cz/weicicz_setup_win.exe",
      "target": "_blank"
    }
  }, [_c('img', {
    attrs: {
      "src": __webpack_require__(10)
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "product_des"
  }, [_c('p', [_vm._v("点击下载")]), _vm._v(" "), _c('p', [_vm._v("初中维词教学系统")]), _vm._v(" "), _c('p', [_vm._v("（PC客户端）")])])]), _vm._v(" "), _c('a', {
    staticClass: "product_item",
    attrs: {
      "href": "https://bsource.weicistudy.com/pc_download/cz/weicicz_setup_mac.dmg",
      "target": "_blank"
    }
  }, [_c('img', {
    attrs: {
      "src": __webpack_require__(15)
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "product_des"
  }, [_c('p', [_vm._v("点击下载")]), _vm._v(" "), _c('p', [_vm._v("初中维词教学系统")]), _vm._v(" "), _c('p', [_vm._v("（MAC客户端）")])])]), _vm._v(" "), _c('div', {
    staticClass: "product_item"
  }, [_c('img', {
    staticStyle: {
      "width": "176px",
      "height": "176px"
    },
    attrs: {
      "src": __webpack_require__(57)
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "product_des"
  }, [_c('p', [_vm._v("扫码下载")]), _vm._v(" "), _c('p', [_vm._v("初中维词教师版")]), _vm._v(" "), _c('p', [_vm._v("APP移动端")])])])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "download"
  }, [_c('a', {
    attrs: {
      "href": "https://itunes.apple.com/cn/app/%E7%BB%B4%E8%AF%8D%E5%88%9D%E4%B8%AD%E7%89%88/id1228082964?mt=8",
      "target": "_blank"
    }
  }, [_c('img', {
    attrs: {
      "src": __webpack_require__(9)
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "line"
  }), _vm._v(" "), _c('a', {
    attrs: {
      "href": "http://android.myapp.com/myapp/detail.htm?apkName=com.victorstudy.weici.junior",
      "target": "_blank"
    }
  }, [_c('img', {
    attrs: {
      "src": __webpack_require__(7)
    }
  })])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "text"
  }, [_c('p', [_vm._v("维词教师版是一款")]), _vm._v(" "), _c('p', [_vm._v("为初中英语老师精心准备的教学辅助工具")]), _vm._v(" "), _c('p', [_vm._v("内容融入英语教学各个场景  为学生英语学习提供帮助")]), _vm._v(" "), _c('p', [_vm._v("WEICI App (Teacher's Edition) ")]), _vm._v(" "), _c('p', [_vm._v("is specially designed as an effective tool")]), _vm._v(" "), _c('p', [_vm._v("for Junior High School English teachers to help their students improve scores.")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "arrow"
  }, [_c('img', {
    attrs: {
      "src": __webpack_require__(3)
    }
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "card_text"
  }, [_c('p', {
    staticClass: "title"
  }, [_vm._v("精选优质内容")]), _vm._v(" "), _c('p', {
    staticClass: "title"
  }, [_vm._v("给老师赋能")]), _vm._v(" "), _c('p', [_vm._v("大数据标注历年考点，多维度精讲词汇")]), _vm._v(" "), _c('p', [_vm._v("专业教学设计，精准同步教材")]), _vm._v(" "), _c('p', [_vm._v("优质课件、影音词汇讲解，备课资源丰富 ")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "card_text right"
  }, [_c('p', {
    staticClass: "title"
  }, [_vm._v("智能分析")]), _vm._v(" "), _c('p', {
    staticClass: "title"
  }, [_vm._v("帮学生查漏补缺")]), _vm._v(" "), _c('p', [_vm._v("精选题库、多种题型，一键布置作业")]), _vm._v(" "), _c('p', [_vm._v("大数据智能分析，检查作业更轻松")]), _vm._v(" "), _c('p', [_vm._v("分层教学，真正实现因材施教")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "card_text"
  }, [_c('p', {
    staticClass: "title"
  }, [_vm._v("融入教学场景")]), _vm._v(" "), _c('p', {
    staticClass: "title"
  }, [_vm._v("为老师赋能")]), _vm._v(" "), _c('p', [_vm._v("课前预习，讲课更轻松")]), _vm._v(" "), _c('p', [_vm._v("课上多种教学方式，激发学生英语学习兴趣")]), _vm._v(" "), _c('p', [_vm._v("课后巩固、查漏补缺，培养学生好习惯")])])
}]}

/***/ }),
/* 90 */
/***/ (function(module, exports, __webpack_require__) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('my-menu', {
    attrs: {
      "menu-name": "discovery"
    }
  }), _vm._v(" "), _c('swiper', {
    ref: "swiper1",
    attrs: {
      "options": _vm.swiperOption
    }
  }, [_c('swiper-slide', [_c('img', {
    staticStyle: {
      "width": "100%",
      "height": "600px"
    },
    attrs: {
      "src": __webpack_require__(8)
    }
  })]), _vm._v(" "), _c('swiper-slide', [_c('img', {
    staticStyle: {
      "width": "100%",
      "height": "600px"
    },
    attrs: {
      "src": __webpack_require__(14)
    }
  })]), _vm._v(" "), _c('swiper-slide', [_c('img', {
    staticStyle: {
      "width": "100%",
      "height": "600px"
    },
    attrs: {
      "src": __webpack_require__(54)
    }
  })]), _vm._v(" "), _c('swiper-slide', [_c('img', {
    staticStyle: {
      "width": "100%",
      "height": "600px"
    },
    attrs: {
      "src": __webpack_require__(8)
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "swiper-pagination",
    attrs: {
      "slot": "pagination"
    },
    slot: "pagination"
  }), _vm._v(" "), _c('div', {
    staticClass: "swiper-button-prev",
    attrs: {
      "slot": "button-prev"
    },
    slot: "button-prev"
  }), _vm._v(" "), _c('div', {
    staticClass: "swiper-button-next",
    attrs: {
      "slot": "button-next"
    },
    slot: "button-next"
  })], 1), _vm._v(" "), _c('section', {
    staticClass: "d_content"
  }, [_vm._m(0), _vm._v(" "), _c('ul', {
    staticClass: "cr_list"
  }, _vm._l((_vm.classes), function(item) {
    return _c('li', {
      key: item.id
    }, [_c('router-link', {
      attrs: {
        "to": {
          name: 'ClassDetail',
          params: {
            id: item.id
          }
        }
      }
    }, [_c('img', {
      directives: [{
        name: "lazy",
        rawName: "v-lazy",
        value: (item.img_url),
        expression: "item.img_url"
      }]
    }), _vm._v(" "), _c('div', {
      staticClass: "class_info"
    }, [_c('p', {
      staticClass: "class_title"
    }, [_vm._v(_vm._s(item.title))]), _vm._v(" "), _c('p', {
      staticClass: "class_date"
    }, [_vm._v(_vm._s(item.date))]), _vm._v(" "), _c('p', {
      staticClass: "class_content"
    }, [_vm._v(_vm._s(item.desc))])])])], 1)
  }), 0), _vm._v(" "), _c('div', {
    staticClass: "clear"
  }), _vm._v(" "), _c('div', {
    staticClass: "d_navigation"
  }, [_c('span', {
    staticClass: "nav_title"
  }, [_vm._v("听英语")]), _vm._v(" "), _c('ul', [_c('li', [_c('a', {
    class: {
      cur: _vm.audio.listen
    },
    attrs: {
      "href": "javascript:;"
    },
    on: {
      "click": function($event) {
        return _vm.slideTo(0)
      }
    }
  }, [_vm._v("听力")])]), _vm._v(" "), _c('li', [_c('a', {
    class: {
      cur: _vm.audio.music
    },
    attrs: {
      "href": "javascript:;"
    },
    on: {
      "click": function($event) {
        return _vm.slideTo(1)
      }
    }
  }, [_vm._v("音乐")])]), _vm._v(" "), _vm._m(1)])]), _vm._v(" "), _c('div', {
    staticClass: "listen_container"
  }, [_c('a', {
    staticClass: "arrow_left",
    attrs: {
      "href": "javascript:;"
    },
    on: {
      "click": _vm.leftSwiper
    }
  }), _vm._v(" "), _c('swiper', {
    ref: "swiper2",
    staticClass: "swiper-container listen_list",
    attrs: {
      "options": _vm.swiperOption2
    }
  }, [_c('swiper-slide', {
    staticClass: "swiper-slide"
  }, [_c('div', {
    staticClass: "slide"
  }, [_c('a', {
    attrs: {
      "href": "#"
    }
  }, [_c('div', {
    staticClass: "listen_cover"
  }, [_c('img', {
    attrs: {
      "src": __webpack_require__(5)
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "listen_title"
  }, [_vm._v("高一听力")])]), _vm._v(" "), _c('a', {
    attrs: {
      "href": "#"
    }
  }, [_c('div', {
    staticClass: "listen_cover"
  }, [_c('img', {
    attrs: {
      "src": __webpack_require__(5)
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "listen_title"
  }, [_vm._v("初一听力")])]), _vm._v(" "), _c('a', {
    attrs: {
      "href": "#"
    }
  }, [_c('div', {
    staticClass: "listen_cover"
  }, [_c('img', {
    attrs: {
      "src": __webpack_require__(5)
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "listen_title"
  }, [_vm._v("高二听力")])]), _vm._v(" "), _c('a', {
    attrs: {
      "href": "#"
    }
  }, [_c('div', {
    staticClass: "listen_cover"
  }, [_c('img', {
    attrs: {
      "src": __webpack_require__(5)
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "listen_title"
  }, [_vm._v("高三听力")])])])]), _vm._v(" "), _c('swiper-slide', {
    staticClass: "swiper-slide"
  }, [_c('div', {
    staticClass: "slide"
  }, [_c('a', {
    attrs: {
      "href": "#"
    }
  }, [_c('div', {
    staticClass: "listen_cover"
  }, [_c('img', {
    attrs: {
      "src": __webpack_require__(4)
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "listen_title"
  }, [_vm._v("Deaf Havan")])]), _vm._v(" "), _c('a', {
    attrs: {
      "href": "#"
    }
  }, [_c('div', {
    staticClass: "listen_cover"
  }, [_c('img', {
    attrs: {
      "src": __webpack_require__(4)
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "listen_title"
  }, [_vm._v("Deaf Havan")])]), _vm._v(" "), _c('a', {
    attrs: {
      "href": "#"
    }
  }, [_c('div', {
    staticClass: "listen_cover"
  }, [_c('img', {
    attrs: {
      "src": __webpack_require__(4)
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "listen_title"
  }, [_vm._v("Deaf Havan")])]), _vm._v(" "), _c('a', {
    attrs: {
      "href": "#"
    }
  }, [_c('div', {
    staticClass: "listen_cover"
  }, [_c('img', {
    attrs: {
      "src": __webpack_require__(4)
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "listen_title"
  }, [_vm._v("Deaf Havan")])])])])], 1), _vm._v(" "), _c('a', {
    staticClass: "arrow_right",
    attrs: {
      "href": "javascript:;"
    },
    on: {
      "click": _vm.rightSwiper
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "clear"
  }), _vm._v(" "), _vm._m(2), _vm._v(" "), _c('ul', {
    staticClass: "article_list"
  }, _vm._l((_vm.articles), function(item) {
    return _c('li', {
      directives: [{
        name: "lazy",
        rawName: "v-lazy:background-image",
        value: (item.img_url),
        expression: "item.img_url",
        arg: "background-image"
      }],
      key: item.id
    }, [_c('router-link', {
      attrs: {
        "to": {
          name: 'ArticleDetail',
          params: {
            id: item.id
          }
        }
      }
    }, [_c('div', {
      staticClass: "vidio_thumb"
    }, [_c('p', {
      staticClass: "thumb_title articl_title"
    }, [_vm._v(_vm._s(item.title))]), _vm._v(" "), _c('p', [_vm._v(_vm._s(item.date))])])])], 1)
  }), 0), _vm._v(" "), _c('div', {
    staticClass: "clear"
  })]), _vm._v(" "), _c('my-footer')], 1)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "d_navigation"
  }, [_c('span', {
    staticClass: "nav_title"
  }, [_vm._v("维学课堂")]), _vm._v(" "), _c('ul', [_c('li', [_c('a', {
    attrs: {
      "href": "#"
    }
  }, [_vm._v("查看更多")])])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('li', [_c('a', {
    attrs: {
      "href": "#"
    }
  }, [_vm._v("查看更多")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "d_navigation"
  }, [_c('span', {
    staticClass: "nav_title"
  }, [_vm._v("推荐文章")]), _vm._v(" "), _c('ul', [_c('li', [_c('a', {
    attrs: {
      "href": "#"
    }
  }, [_vm._v("查看更多")])])])])
}]}

/***/ }),
/* 91 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('my-menu', {
    attrs: {
      "menu-name": "discovery"
    }
  }), _vm._v(" "), _c('my-footer')], 1)
},staticRenderFns: []}

/***/ }),
/* 92 */
/***/ (function(module, exports, __webpack_require__) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "container"
  }, [_c('a', {
    attrs: {
      "href": "#",
      "name": "top"
    }
  }), _vm._v(" "), _c('a', {
    staticClass: "toTop",
    style: ({
      right: _vm.topRight + 'px'
    }),
    attrs: {
      "href": "top"
    }
  }, [_c('img', {
    attrs: {
      "src": __webpack_require__(64),
      "alt": "返回顶部"
    }
  })]), _vm._v(" "), _c('my-menu', {
    attrs: {
      "menu-name": "discovery"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "c_content clearfix"
  }, [_c('ol', {
    staticClass: "breadcrumb"
  }, [_c('li', [_vm._v("\n        当前位置：\n      ")]), _vm._v(" "), _c('li', [_c('router-link', {
    attrs: {
      "to": {
        name: 'Discovery'
      }
    }
  }, [_vm._v("发现")])], 1), _vm._v(" "), _vm._m(0), _vm._v(" "), _c('li', {
    staticClass: "sep active"
  }, [_vm._v("\n        正文\n      ")])]), _vm._v(" "), _c('div', {
    staticClass: "c_detail"
  }, [_c('h1', [_vm._v(_vm._s(_vm.class_detail.title))]), _vm._v(" "), _c('span', {
    staticClass: "c_from"
  }, [_vm._v(_vm._s(_vm.class_detail.date) + " 来源：维克多英语")]), _vm._v(" "), _c('div', {
    domProps: {
      "innerHTML": _vm._s(_vm.class_detail.content)
    }
  })]), _vm._v(" "), _c('hr', {
    staticStyle: {
      "height": "3px",
      "background-color": "#333",
      "width": "100%''"
    }
  }), _vm._v(" "), _vm._m(1)]), _vm._v(" "), _c('my-footer')], 1)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('li', {
    staticClass: "sep"
  }, [_c('a', {
    attrs: {
      "href": "javascript:;"
    }
  }, [_vm._v("维学课堂")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "recommend clearfix"
  }, [_c('h2', [_vm._v("精彩推荐")]), _vm._v(" "), _c('ul', [_c('li', [_c('a', {
    staticClass: "recommend_desc",
    attrs: {
      "href": "javascript:;"
    }
  }, [_vm._v("\n            英语八大时态用法详解态用法详解态\n          ")])]), _vm._v(" "), _c('li', [_c('a', {
    staticClass: "recommend_desc",
    attrs: {
      "href": "javascript:;"
    }
  }, [_vm._v("\n            英语八大时态用法详解态用法详解态用法详解\n          ")])]), _vm._v(" "), _c('li', [_c('a', {
    staticClass: "recommend_desc",
    attrs: {
      "href": "javascript:;"
    }
  }, [_vm._v("\n            英语八大时态用法详解\n          ")])]), _vm._v(" "), _c('li', [_c('a', {
    staticClass: "recommend_desc",
    attrs: {
      "href": "javascript:;"
    }
  }, [_vm._v("\n            英语八大时态用法详解态用法详解态\n          ")])]), _vm._v(" "), _c('li', [_c('a', {
    staticClass: "recommend_desc",
    attrs: {
      "href": "javascript:;"
    }
  }, [_vm._v("\n            英语八大时态用法详解态\n          ")])]), _vm._v(" "), _c('li', [_c('a', {
    staticClass: "recommend_desc",
    attrs: {
      "href": "javascript:;"
    }
  }, [_vm._v("\n            英语八大时态用法详解态用法详解态用法详解\n          ")])])])])
}]}

/***/ }),
/* 93 */
/***/ (function(module, exports, __webpack_require__) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('my-menu', {
    attrs: {
      "menu-name": "msg"
    }
  }), _vm._v(" "), _c('div', {
    staticStyle: {
      "margin": "100px auto",
      "width": "70%",
      "border": "1px solid #e6e6e6",
      "padding": "19px"
    }
  }, [_vm._m(0), _vm._v(" "), _c('ul', {
    staticStyle: {
      "padding": "0"
    }
  }, [_vm._m(1), _vm._v(" "), _c('div', {
    staticStyle: {
      "width": "100%",
      "height": "4rem"
    }
  }, [_c('div', {
    staticStyle: {
      "float": "left",
      "width": "86%",
      "height": "auto",
      "padding-left": "18px"
    }
  }, [_vm._v("学英语并无捷径和秘诀可寻。但是经验告诉我们，总有些技巧和方法可以对学习有些帮助。下面所述这些方法，都是实际可行的，并不是空谈和理论，大家依自己的需要可以选择几项去试一试。")]), _vm._v(" "), _c('div', {
    staticStyle: {
      "float": "right",
      "width": "10%",
      "text-align": "center"
    }
  }, [_c('button', {
    staticStyle: {
      "color": "red",
      "border": "1px solid #8c8c8c",
      "-webkit-border-radius": "3px",
      "-moz-border-radius": "3px",
      "border-radius": "3px"
    },
    on: {
      "click": _vm.subHandle
    }
  }, [_vm._v("¥2订阅")])])]), _vm._v(" "), _vm._m(2), _vm._v(" "), _c('div', {
    staticStyle: {
      "width": "100%",
      "height": "4rem"
    }
  }, [_c('div', {
    staticStyle: {
      "float": "left",
      "width": "86%",
      "height": "auto",
      "padding-left": "18px"
    }
  }, [_vm._v("英语口语好，到底有多重要？口语学习中，我们都太重视说而忽略了听，这样也就很难发现自己口语的缺陷究竟在哪里。十个妙教你用最简单的方法，学最流利的英语口语，快速天掌握基本对话。")]), _vm._v(" "), _c('div', {
    staticStyle: {
      "float": "right",
      "width": "10%",
      "text-align": "center"
    }
  }, [_c('button', {
    staticStyle: {
      "color": "red",
      "border": "1px solid #8c8c8c",
      "-webkit-border-radius": "3px",
      "-moz-border-radius": "3px",
      "border-radius": "3px"
    },
    on: {
      "click": _vm.subHandle
    }
  }, [_vm._v("¥2订阅")])])]), _vm._v(" "), _vm._m(3), _vm._v(" "), _c('div', {
    staticStyle: {
      "width": "100%",
      "height": "4rem"
    }
  }, [_c('div', {
    staticStyle: {
      "float": "left",
      "width": "86%",
      "height": "auto",
      "padding-left": "18px"
    }
  }, [_vm._v("高考提分秘籍来了，最后冲刺还能再提5分！相信高考临近的这个时候，每一位奋战在高考前线的同学都进入“两耳不闻窗外事，一心只做冲刺卷”的状态。")]), _vm._v(" "), _c('div', {
    staticStyle: {
      "float": "right",
      "width": "10%",
      "text-align": "center"
    }
  }, [_c('button', {
    staticStyle: {
      "color": "red",
      "border": "1px solid #8c8c8c",
      "-webkit-border-radius": "3px",
      "-moz-border-radius": "3px",
      "border-radius": "3px"
    },
    on: {
      "click": _vm.subHandle
    }
  }, [_vm._v("¥2订阅")])])]), _vm._v(" "), _vm._m(4), _vm._v(" "), _c('div', {
    staticStyle: {
      "width": "100%",
      "height": "4rem"
    }
  }, [_c('div', {
    staticStyle: {
      "float": "left",
      "width": "86%",
      "height": "auto",
      "padding-left": "18px"
    }
  }, [_vm._v("提起英文阅读理解，很多同学是一把“辛酸泪”，生词多，读不懂；即使单词都认识，却常常还是读不懂。一旦读不懂，就会影响做题的时间和质量，高中英语考试中阅读理解的九大题型和解题技巧，帮助你提高做题的正确率。")]), _vm._v(" "), _c('div', {
    staticStyle: {
      "float": "right",
      "width": "10%",
      "text-align": "center"
    }
  }, [_c('button', {
    staticStyle: {
      "color": "red",
      "border": "1px solid #8c8c8c",
      "-webkit-border-radius": "3px",
      "-moz-border-radius": "3px",
      "border-radius": "3px"
    },
    on: {
      "click": _vm.subHandle
    }
  }, [_vm._v("¥2订阅")])])])])]), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.dialogShow),
      expression: "dialogShow"
    }],
    staticClass: "dialog"
  }, [_c('div', {
    staticStyle: {
      "background-color": "#f3f3f3",
      "border-bottom": "solid 1px #eee",
      "margin": "0",
      "z-index": "auto"
    }
  }, [_c('span', {
    staticStyle: {
      "display": "inline-block",
      "height": "20px",
      "padding": "10px 20px",
      "border": "none 0"
    }
  }, [_vm._v("请扫描支付")]), _vm._v(" "), _c('span', {
    staticStyle: {
      "font-family": "Verdana",
      "font-size": "14px",
      "line-height": "20px",
      "color": "#999",
      "text-align": "center",
      "display": "inline-block",
      "width": "20px",
      "height": "20px",
      "position": "absolute",
      "z-index": "1",
      "top": "10px",
      "right": "10px",
      "cursor": "pointer"
    },
    on: {
      "click": _vm.closeDialog
    }
  }, [_vm._v("×")])]), _vm._v(" "), _vm._m(5)]), _vm._v(" "), _c('my-footer')], 1)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticStyle: {
      "border-bottom": "1px solid #e6e6e6",
      "padding-bottom": "15px",
      "margin-bottom": "15px"
    }
  }, [_c('h2', {
    staticStyle: {
      "padding": "0",
      "margin": "0"
    }
  }, [_vm._v("有偿资讯")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('li', {
    staticStyle: {
      "line-height": "20px",
      "display": "block",
      "height": "20px",
      "padding": "5px 0"
    }
  }, [_c('i', {
    staticStyle: {
      "background-color": "#666",
      "vertical-align": "middle",
      "display": "inline-block",
      "width": "3px",
      "height": "3px",
      "margin-right": "10px"
    }
  }), _vm._v(" "), _c('b', [_vm._v("怎么学英语")]), _vm._v(" "), _c('span', {
    staticStyle: {
      "font-size": "11px",
      "color": "#aaa",
      "float": "right"
    }
  }, [_vm._v("2020-03-25 14:53")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('li', {
    staticStyle: {
      "line-height": "20px",
      "display": "block",
      "height": "20px",
      "padding": "5px 0"
    }
  }, [_c('i', {
    staticStyle: {
      "background-color": "#666",
      "vertical-align": "middle",
      "display": "inline-block",
      "width": "3px",
      "height": "3px",
      "margin-right": "10px"
    }
  }), _vm._v(" "), _c('b', [_vm._v("十个妙招教你快速练就好口语")]), _vm._v(" "), _c('span', {
    staticStyle: {
      "font-size": "11px",
      "color": "#aaa",
      "float": "right"
    }
  }, [_vm._v("2019-09-01 09:13")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('li', {
    staticStyle: {
      "line-height": "20px",
      "display": "block",
      "height": "20px",
      "padding": "5px 0"
    }
  }, [_c('i', {
    staticStyle: {
      "background-color": "#666",
      "vertical-align": "middle",
      "display": "inline-block",
      "width": "3px",
      "height": "3px",
      "margin-right": "10px"
    }
  }), _vm._v(" "), _c('b', [_vm._v("高考英语提分秘籍来了！")]), _vm._v(" "), _c('span', {
    staticStyle: {
      "font-size": "11px",
      "color": "#aaa",
      "float": "right"
    }
  }, [_vm._v("2019-06-23 15:09")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('li', {
    staticStyle: {
      "line-height": "20px",
      "display": "block",
      "height": "20px",
      "padding": "5px 0"
    }
  }, [_c('i', {
    staticStyle: {
      "background-color": "#666",
      "vertical-align": "middle",
      "display": "inline-block",
      "width": "3px",
      "height": "3px",
      "margin-right": "10px"
    }
  }), _vm._v(" "), _c('b', [_vm._v("高中英语阅读理解解题技巧，教你一眼看出正确答案")]), _vm._v(" "), _c('span', {
    staticStyle: {
      "font-size": "11px",
      "color": "#aaa",
      "float": "right"
    }
  }, [_vm._v("2019-05-05 10:03")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticStyle: {
      "width": "342.4px",
      "height": "465.6px"
    }
  }, [_c('img', {
    staticStyle: {
      "width": "100%",
      "height": "100%"
    },
    attrs: {
      "src": __webpack_require__(62)
    }
  })])
}]}

/***/ }),
/* 94 */
/***/ (function(module, exports, __webpack_require__) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "menu"
  }, [_vm._m(0), _vm._v(" "), _c('div', {
    staticClass: "nav"
  }, [_c('ul', {
    staticClass: "main_menu"
  }, [_c('li', {
    class: {
      cur: _vm.menu.home
    }
  }, [_c('router-link', {
    style: ({
      color: (_vm.menu.home ? '#fff' : '')
    }),
    attrs: {
      "to": {
        name: 'Teacher'
      }
    }
  }, [_vm._v("高中")])], 1), _vm._v(" "), _c('li', {
    class: {
      cur: _vm.menu.junior
    }
  }, [_c('router-link', {
    style: ({
      color: (_vm.menu.junior ? '#fff' : '')
    }),
    attrs: {
      "to": {
        name: 'Teachercz'
      }
    }
  }, [_vm._v("初中")])], 1), _vm._v(" "), _c('li', {
    class: {
      cur: _vm.menu.about
    }
  }, [_c('router-link', {
    style: ({
      color: (_vm.menu.about ? '#fff' : '')
    }),
    attrs: {
      "to": {
        name: 'About'
      }
    }
  }, [_vm._v("关于我们")])], 1)]), _vm._v(" "), _c('div', {
    staticClass: "curBg"
  })])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('a', {
    staticClass: "a_logo",
    attrs: {
      "href": "/"
    }
  }, [_c('div', {
    staticClass: "logo"
  }, [_c('img', {
    attrs: {
      "src": __webpack_require__(59)
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "com_name"
  }, [_vm._v("\n          维词\n      ")])])
}]}

/***/ }),
/* 95 */,
/* 96 */,
/* 97 */,
/* 98 */
/***/ (function(module, exports) {

module.exports = {"articles":[{"id":1,"title":"文章测试1","date":"2017-04-23","img_url":"../../../static/images/cz1.png","content":""},{"id":2,"title":"文章测试2","date":"2017-01-24","img_url":"../../../static/images/cz2.png","content":""},{"id":3,"title":"文章测试3","date":"2017-01-24","img_url":"../../../static/images/cz3.png","content":""},{"id":4,"title":"文章测试4","date":"2017-04-23","img_url":"../../../static/images/cz1.png","content":""},{"id":5,"title":"文章测试5","date":"2017-01-24","img_url":"../../../static/images/cz2.png","content":""},{"id":6,"title":"文章测试6","date":"2017-01-24","img_url":"../../../static/images/cz3.png","content":""},{"id":7,"title":"文章测试7","date":"2017-04-23","img_url":"../../../static/images/cz1.png","content":""},{"id":8,"title":"文章测试8","date":"2017-01-24","img_url":"../../../static/images/cz2.png","content":""},{"id":9,"title":"文章测试8","date":"2017-01-24","img_url":"../../../static/images/cz3.png","content":""}]}

/***/ }),
/* 99 */
/***/ (function(module, exports) {

module.exports = {"positions":[{"name":"产品经理","category":"product","require":"<p>1、两年以上移动产品相关经验，社交类产品尤佳；</p><p>2、具备较强的逻辑思维能与用户体验细节把控能力，具有较好的用户同理心；</p><p>3、熟悉Android与iOS平台特性，设计规范及其异同点；</p><p>4、深度移动互联网用户，产品控，熟悉国内外各大榜单焦点产品，完美主义者，追求 体验极致；</p><p>5、具备良好的沟通协调以及强有力的业务推动能力；</p><p>6、熟悉各类办公软件与产品工具，能够输出高质量的产品文档与原型；</p><p>7、具备较好的文字功底，能够输出高质量的调研报告并设计符合目标用户偏好的产品文案；</p><p>8、具备敏锐的数据Sense,卓越的项目管理能力以及快速学习能力；</p><p>9、同样欢迎对PM工作感兴趣并对用户体验有深刻理解的交互设计师应聘本职位；</p><p>10、如果现在的你依然坚持着改变世界的理想，那么，我们热切地希望你能过来聊聊。</p>","content":"<p>1、负责公司移动端产品（Android&iOS）设计与管理工作；</p><p>2、以公司目标为导向，结合市场竞争与业务发展情况，制定产品需求与项目可行性方案；</p><p>3、关注产品各项常规数据与指标，通过统计和分析验证构想并指导产品改进方向，根据上级需要提出细粒度数据挖掘需求；</p><p>4、根据项目需要输出高质量的市场需求文档，产品需求文档，产品原型；</p><p>5、协调内外部资源，对接技术团队，设计团队以及运营市场团队，推进产6.完成产品市场调研，国内外竞品跟踪以及用户研究等工作，并输出高质量的调研报告；</p><p>7、收集用户反馈，提升用户满意度，将用户体验做到极致；</p><p>8、关注国内外互联网动向，发掘市场需求，参与新业务方向的探索与制定。 </p>"},{"name":"APP测试工程师","category":"technology","require":"<p>1、本科及及以上学历，计算机相关专业</p><p>2、熟悉移动端设备，2年以上移动端APP产品测试经验</p><p>3、熟悉软件测试基本理论，掌握常用测试工具、软件测试流程，掌握软件测试技巧</p><p>4、熟悉移动端测试流程，能够熟练编写高质量的测试用例</p><p>5、逻辑思维缜密，业务理解能力强，能够从用户角度把控产品体验，认真，细心</p><p>6、抗压能力强，具有强烈的责任感与团队合作精神，出色的沟通及学习能力</p><p>7、熟悉APP性能测试工具、Appium自动化测试、有开发经验或自动化脚本编写能力者优先</p>","content":"<p>1、负责移动平台APP（IOS、Android）产品的功能测试</p><p>2、根据需求独立完成测试计划及测试用例的编写，参与测试用例的评审</p><p>3、负责根据测试计划及测试用例执行测试，缺陷的跟踪和管理，输出测试报告</p><p>4、参与产品需求阶段的评审</p><p>5、熟悉bug生命周期流程，与研发人员沟通并深层次定位bug产生的原因</p><p>6、熟悉APP端与服务端联调测试以及异常情况测试</p>"},{"name":"iOS开发工程师","category":"technology","require":"<p>1、本科学历，计算机相关专业，2年iOS客户端开发经验; </p><p>2、熟悉iOS界面设计开发，熟悉Xcode开发环境及iOS SDK，熟练使用iOS开发工具以及测试、调试工具的使用；</p><p>3、具备扎实的C++语言基础和数据结构/算法基础，熟悉基于TCP/HTTP协议的网络协议； </p><p>4、熟练掌握object-c代码优先技巧，熟练使用多种常用设计模式; </p><p>5、具备优秀的独立工作及解决问题的能力，并具备一定的测试方法和技巧；</p>","content":"<p>1、负责iOS客户端开发工作；</p><p>2、根据产品需求完成架构和模块设计、编码工作； </p><p>3、独立完成IOS平台软件开发、验证和修正测试中发现的问题；  </p><p>4、根据产品功能需求设计并完成软件实现；</p><p>5、能按需求独立完成，初步的需求分析，配合美工完成UI的设计，独立完成IOS端的开发，能按开发计划按时完成开发任务，具备简单的APP测试能力能配合完成部门内的例行性工作。 </p>"},{"name":"应用设计师","category":"design","require":"<p>1、本科以上学历，计算机，软件工程等相关专业；</p><p>2、人机交互、视觉设计、艺术设计、工业设计等相关专业第二学历优先考虑，有UI设计工作经验者优先； </p><p>3、两年年以上应用系统咨询或者规划经验，或者两年年以上IT行业应用开发和项目管理经验；</p><p>4、熟悉主流软件技术架构，熟悉主流操作系统，数据库和中间件等软件产品的特性与应用，接触过报表及BI工具的优先；</p><p>5、思路清晰，有很强的的理解能力和应变能力，强烈的成就导向意识，善于学习，有团队合作意识；</p><p>6、具备较强的自信心，和沟通表达能力，善于分析总结，能够与客户在业务、技术等方面有良好的沟通，熟练操作PPT，word等办公软件；</p><p>7. 熟练使用 PPT、Office visio、axure；</p>","content":"<p>1、负责产品（pc、app）的BI应用开发；</p><p>2、配合专家部门对BI应用进行UI美化；</p><p>3、参与产品的用户体验分析，跟踪产品的体验效果，从用户体验的角度出发，提出最佳的交互设计和界面设计方案，持续改进产品。</p><p>4、参与售前售后和咨询工作。</p>"},{"name":"产品运营","category":"operation","require":"<p>1、热爱产品运营工作，熟悉互联网产品运营的知识和方法。</p><p>2、对互联网产品、特别是面向企业客户、开发者产品的互联网产品有一定的了解，能够对相关产品有自己的认识和理解。</p><p>3、有较强的沟通能力，喜欢和他人交流互动，善于处理复杂困难或突发状况的人际交互问题。</p><p>4、有自己的个人文案、微博、博客等并体现自身特色者优先。</p><p>5、有同类项目（互联网应用、SAAS、API平台）运营经验者优先。</p><p>6、不少于3年的互联网产品运营经验。</p>","content":"<p>1、根据公司产品计划和市场计划开展运营工作。</p><p>2、制定运营计划，并根据运营效果进行评估。</p><p>3、通过运营工作推广产品、提高产品知名度、扩大用户量。</p><p>4、反馈运营工作数据、意见以便推进产品迭代。</p>"}]}

/***/ })
],[21]);


// WEBPACK FOOTER //
// static/js/app.fed859e40b8ccceaacc2.js